
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import baseAPIService from '../services/baseapiservice';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { prefetchRoute } from '../modules/business/maud-erp/routePrefetch';
import { ListSkeleton } from '@/components/base/Skeleton';
import { useDisplayDevicesInboxBadge } from '../modules/business/maud-erp/display-devices/sidebar/inboxBadge';
import { useSidebarStore } from '@/stores/sidebarStore';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  onToggle: () => void;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  isPinned?: boolean;
  menuItems?: NavItem[];
}

interface SubItem {
  mnu_itm_nm: string;
  t_mnu_itm_nm?: string;
  mnu_dscn_tx?: string;
  mnu_itm_icn_tx?: string;
  mnu_itm_icn_clr_tx?: string;
  mnu_itm_icn_clr_cd?: string;
  mnu_itm_url_tx: string;
  mnu_vw_in?: 'sidemenu' | 'submenu' | 'cardmenu';
  prnt_mnu_itm_id?: number;
  // Postgres BOOLEAN — reaches the client as true / 't' / 1 depending on serialisation.
  hdr_in?: number | boolean | string;
  prnt_hdr_in?: number | boolean | string;
  // Section wing = the tier BELOW the module (Planning, Sanctions, Payments … in
  // WMS (NEW)). Same master table as the module wing on NavItem, opposite
  // direction: this one is carried by the child and groups it inside its module.
  // Absent on every module that has not been sectioned. See applySectionWings().
  sctn_wng_id?: number | string | null;
  sctn_wng_cd?: string;
  sctn_wng_nm?: string;
  sctn_t_wng_nm?: string;
  sctn_wng_icn_tx?: string;
  sctn_wng_icn_clr_cd?: string;
  sctn_wng_sqnce_id?: number | string;
  children?: SubItem[];
}

interface NavItem {
  mnu_itm_nm: string;
  t_mnu_itm_nm?: string;
  mnu_dscn_tx?: string;
  mnu_itm_icn_tx?: string;
  mnu_itm_icn_clr_tx?: string;
  mnu_itm_icn_clr_cd?: string;
  prnt_mnu_icn_tx?: string;
  prnt_mnu_icn_clr_cd?: string;
  mnu_itm_url_tx: string;
  mnu_vw_in?: 'sidemenu' | 'submenu' | 'cardmenu' | 1;
  prnt_mnu_itm_id?: number;
  // Postgres BOOLEAN — see SubItem above.
  hdr_in?: number | boolean | string;
  prnt_hdr_in?: number | boolean | string;
  children?: SubItem[];
  // Wing = the grandparent tier (Finance Wing, Planning Wing, …). Supplied by
  // erp-auth/menu from ds_dtcp.app_wng_lst_t. Display grouping only — modules are
  // still granted to roles individually, wings are never assignable.
  wng_id?: number | string;
  wng_cd?: string;
  wng_nm?: string;
  t_wng_nm?: string;
  wng_icn_tx?: string;
  wng_icn_clr_cd?: string;
  wng_sqnce_id?: number | string;
}

// A wing with the modules that belong to it, as rendered in the sidebar.
interface WingGroup {
  wng_id: string;
  wng_cd?: string;
  wng_nm: string;
  t_wng_nm?: string;
  wng_icn_tx?: string;
  wng_icn_clr_cd?: string;
  wng_sqnce_id: number;
  items: any[];
}

const defaultNavItems: NavItem[] = [
  // { 
  //   mnu_itm_nm: 'Dashboard', 
  //   t_mnu_itm_nm: 'డాష్‌బోర్డ్',
  //   mnu_itm_url_tx: '/dashboard',
  //   mnu_itm_icn_tx: 'ri-dashboard-line',
  //   mnu_dscn_tx: 'Overview & Summary'
  // },
  // { 
  //   mnu_itm_nm: 'APUFIDC', 
  //   t_mnu_itm_nm: 'APUFIDC',
  //   mnu_itm_url_tx: '/apps/APUFIDC/dashboard',
  //   mnu_itm_icn_tx: 'ri-dashboard-line',
  //   mnu_dscn_tx: 'Overview & Summary'
  // },
  // { 
  //   mnu_itm_nm: 'AI Agents', 
  //   t_mnu_itm_nm: 'AI ఏజెంట్లు',
  //   mnu_itm_url_tx: '/ai-agents',
  //   mnu_itm_icn_tx: 'ri-robot-line',
  //   mnu_dscn_tx: 'AI Agents Services',
  //   mnu_vw_in: 'submenu',
  //   children: [
  //     { mnu_itm_nm: 'Dashboard', t_mnu_itm_nm: 'డాష్‌బోర్డ్', mnu_itm_url_tx: '/ai-agents/dashboard', mnu_itm_icn_tx: 'ri-dashboard-line' },
  //     { mnu_itm_nm: 'Knowledge Base', t_mnu_itm_nm: 'నాలెడ్జ్ బేస్', mnu_itm_url_tx: '/ai-agents/knowledge-base', mnu_itm_icn_tx: 'ri-file-list-line' }
  //   ]
  // },




  // { 
  //   mnu_itm_nm: 'Analytics & Reports', 
  //   t_mnu_itm_nm: 'విశ్లేషణలు మరియు నివేదికలు',
  //   mnu_itm_url_tx: '#analytics-reports',
  //   mnu_itm_icn_tx: 'ri-bar-chart-line',
  //   hdr_in: 1
  // },
  // { 
  //   mnu_itm_nm: 'Analytics', 
  //   t_mnu_itm_nm: 'విశ్లేషణలు',
  //   mnu_itm_url_tx: '/analytics',
  //   mnu_itm_icn_tx: 'ri-bar-chart-line',
  //   mnu_dscn_tx: 'Analytics Dashboard',
  //   mnu_vw_in: 'cardmenu',
  //   children: [
  //     { mnu_itm_nm: 'Dashboards', t_mnu_itm_nm: 'డాష్‌బోర్డ్‌లు', mnu_itm_url_tx: '/dashboard-builder', mnu_itm_icn_tx: 'ri-dashboard-line', mnu_dscn_tx: 'Interactive dashboards and charts' },
  //     { mnu_itm_nm: 'Insights', t_mnu_itm_nm: 'అంతర్దృష్టిలు', mnu_itm_url_tx: '/data-insights', mnu_itm_icn_tx: 'ri-lightbulb-line', mnu_dscn_tx: 'Data insights and trends' },
  //     { mnu_itm_nm: 'Reports', t_mnu_itm_nm: 'నివేదికలు', mnu_itm_url_tx: '/reports', mnu_itm_icn_tx: 'ri-file-list-3-line', mnu_dscn_tx: 'Generate detailed reports' },
  //     { mnu_itm_nm: 'Registers', t_mnu_itm_nm: 'రిజిస్టర్‌లు', mnu_itm_url_tx: '/registers', mnu_itm_icn_tx: 'ri-book-line', mnu_dscn_tx: 'Manage data registers' }
  //   ]
  // },
  // { 
  //   mnu_itm_nm: 'Reports', 
  //   t_mnu_itm_nm: 'నివేదికలు',
  //   mnu_itm_url_tx: '/reports',
  //   mnu_itm_icn_tx: 'ri-bar-chart-2-line',
  //   mnu_dscn_tx: 'Business Reports & Analytics'
  // },
  // { 
  //   mnu_itm_nm: 'Tools & Utilities', 
  //   t_mnu_itm_nm: 'సాధనాలు మరియు వినియోగాలు',
  //   mnu_itm_url_tx: '#tools-utilities',
  //   mnu_itm_icn_tx: 'ri-tools-line',
  //   hdr_in: 1
  // },
  // { 
  //   mnu_itm_nm: 'Document Library', 
  //   t_mnu_itm_nm: 'డాక్యుమెంట్ లైబ్రరీ',
  //   mnu_itm_url_tx: '/document-library',
  //   mnu_itm_icn_tx: 'ri-folder-open-line',
  //   mnu_dscn_tx: 'Document Management & Storage'
  // },  
  {
    mnu_itm_nm: 'Map Masters',
    t_mnu_itm_nm: 'మ్యాప్ మాస్టర్',
    mnu_itm_url_tx: '/maps',
    mnu_itm_icn_tx: 'ri-map-line',
    mnu_dscn_tx: 'Manage GIS Maps',
    mnu_vw_in: 'sidemenu',
    children: [
      // { mnu_itm_nm: 'Maps', t_mnu_itm_nm: 'మ్యాప్', mnu_itm_url_tx: '/maps', mnu_itm_icn_tx: 'ri-map-2-line' },
      { mnu_itm_nm: 'Data Stores', t_mnu_itm_nm: 'డేటా స్టోర్లు', mnu_itm_url_tx: '/stores', mnu_itm_icn_tx: 'ri-database-line', mnu_dscn_tx: 'Data Stores Management' },
      { mnu_itm_nm: 'Layer Groups', t_mnu_itm_nm: 'పొర సమూహాలు', mnu_itm_url_tx: '/layer-groups', mnu_itm_icn_tx: 'ri-group-line' },
      { mnu_itm_nm: 'Layers', t_mnu_itm_nm: 'పొరలు', mnu_itm_url_tx: '/layers', mnu_itm_icn_tx: 'ri-stack-line' },
      { mnu_itm_nm: 'Base Layers', t_mnu_itm_nm: 'పొరలు', mnu_itm_url_tx: '/base-layers', mnu_itm_icn_tx: 'ri-stack-line' },
      { mnu_itm_nm: 'Data Layers', t_mnu_itm_nm: 'పొరలు', mnu_itm_url_tx: '/data-layers', mnu_itm_icn_tx: 'ri-stack-line' },
      { mnu_itm_nm: 'Styles', t_mnu_itm_nm: 'శైలులు', mnu_itm_url_tx: '/styles', mnu_itm_icn_tx: 'ri-palette-line' },
      { mnu_itm_nm: 'Workspaces', t_mnu_itm_nm: 'వర్క్‌స్పేస్‌లు', mnu_itm_url_tx: '/workspaces', mnu_itm_icn_tx: 'ri-folder-line', mnu_dscn_tx: 'Manage Workspaces' },
      { mnu_itm_nm: 'External Applications', t_mnu_itm_nm: 'బహిరంగ యాప్‌లు', mnu_itm_url_tx: '/external-applications', mnu_itm_icn_tx: 'ri-external-link-line', mnu_dscn_tx: 'Manage External Applications' },

      // { mnu_itm_nm: 'Layer Groups', t_mnu_itm_nm: 'పొర సమూహాలు', mnu_itm_url_tx: '/layer-groups', mnu_itm_icn_tx: 'ri-group-line', mnu_dscn_tx: 'Layer Group Management' },
      { mnu_itm_nm: 'Tile Caching', t_mnu_itm_nm: 'టైల్ క్యాషింగ్', mnu_itm_url_tx: '/tile-caching', mnu_itm_icn_tx: 'ri-cached-line', mnu_dscn_tx: 'GeoWebCache Management' },
      // { mnu_itm_nm: 'Map Masters', t_mnu_itm_nm: 'మ్యాప్ మాస్టర్', mnu_itm_url_tx: '/map-masters', mnu_itm_icn_tx: 'ri-map-line', mnu_dscn_tx: 'Map Masters Management' },
      { mnu_itm_nm: 'Vector Maps', t_mnu_itm_nm: 'వెక్టర్ మ్యాప్స్', mnu_itm_url_tx: '/vector-maps', mnu_itm_icn_tx: 'ri-map-2-line', mnu_dscn_tx: 'Test Vector Tile Layers' },
      // { mnu_itm_nm: 'Map', t_mnu_itm_nm: 'మ్యాప్', mnu_itm_url_tx: '/map', mnu_itm_icn_tx: 'ri-map-2-line' },
      {
        mnu_itm_nm: 'Services',
        t_mnu_itm_nm: 'సేవలు',
        mnu_itm_url_tx: '/services',
        mnu_itm_icn_tx: 'ri-server-line',
        mnu_dscn_tx: 'GeoServer Services',
        mnu_vw_in: 'sidemenu',
        children: [
          { mnu_itm_nm: 'WMS', t_mnu_itm_nm: 'WMS', mnu_itm_url_tx: '/services/wms', mnu_itm_icn_tx: 'ri-map-line' },
          { mnu_itm_nm: 'WFS', t_mnu_itm_nm: 'WFS', mnu_itm_url_tx: '/services/wfs', mnu_itm_icn_tx: 'ri-file-list-line' },
          { mnu_itm_nm: 'WCS', t_mnu_itm_nm: 'WCS', mnu_itm_url_tx: '/services/wcs', mnu_itm_icn_tx: 'ri-image-line' },
          { mnu_itm_nm: 'WMTS', t_mnu_itm_nm: 'WMTS', mnu_itm_url_tx: '/services/wmts', mnu_itm_icn_tx: 'ri-grid-line' }
        ]
      }
    ]
  },
  { mnu_itm_nm: 'Map', t_mnu_itm_nm: 'మ్యాప్', mnu_itm_url_tx: '/app/map', mnu_itm_icn_tx: 'ri-map-2-line' },
  { mnu_itm_nm: 'Government Assets', t_mnu_itm_nm: 'ప్రభుత్వ ఆస్తులు', mnu_itm_url_tx: '/app/government-assets', mnu_itm_icn_tx: 'ri-government-line' },
  { mnu_itm_nm: 'Road Network', t_mnu_itm_nm: 'రోడ్ నెట్వర్క్', mnu_itm_url_tx: '/app/road-network', mnu_itm_icn_tx: 'ri-route-line' },
  { mnu_itm_nm: 'Water Network', t_mnu_itm_nm: 'నీటి నెట్వర్క్', mnu_itm_url_tx: '/app/water-network', mnu_itm_icn_tx: 'ri-drop-line' },
  { mnu_itm_nm: 'Sewerage Network', t_mnu_itm_nm: 'సీవరేజీ నెట్వర్క్', mnu_itm_url_tx: '/app/sewerage-network', mnu_itm_icn_tx: 'ri-artboard-2-line' },
  { mnu_itm_nm: 'Greening & Beautification', t_mnu_itm_nm: 'గ్రీనింగ్ & బ్యూటిఫికేషన్', mnu_itm_url_tx: '/app/greening-beautification', mnu_itm_icn_tx: 'ri-tree-line' },
  { mnu_itm_nm: 'Property Tax (PT)', t_mnu_itm_nm: 'ప్రతికూల టాక్', mnu_itm_url_tx: '/app/property-tax', mnu_itm_icn_tx: 'ri-money-rupee-circle-line' },
  { mnu_itm_nm: 'Property Survey', t_mnu_itm_nm: 'రీసుర్వే', mnu_itm_url_tx: '/app/resurvey', mnu_itm_icn_tx: 'ri-survey-line' },
  { mnu_itm_nm: 'Digital Door No (DDN)', t_mnu_itm_nm: 'డిజిటల్ డోర్ నో', mnu_itm_url_tx: '/app/digital-door-no', mnu_itm_icn_tx: 'ri-qr-code-line' },
  { mnu_itm_nm: 'Trade Licenses', t_mnu_itm_nm: 'వాణిజ్య లైసెన్సులు', mnu_itm_url_tx: '/app/trade-licenses', mnu_itm_icn_tx: 'ri-door-open-line' },
  { mnu_itm_nm: 'Street Vendors', t_mnu_itm_nm: 'స్ట్రీట్ వెండర్స్', mnu_itm_url_tx: '/app/street-vendors', mnu_itm_icn_tx: 'ri-store-line' },
  // { <i class="ri-money-rupee-circle-line"></i>
  //   mnu_itm_nm: 'Design System', 
  //   t_mnu_itm_nm: 'డిజైన్ సిస్టమ్',
  //   mnu_itm_url_tx: '/design-system',
  //   mnu_itm_icn_tx: 'ri-palette-line',
  //   mnu_dscn_tx: 'Design System Components',
  //   mnu_vw_in: 'sidemenu',
  //   children: [
  //     { mnu_itm_nm: 'Projects', t_mnu_itm_nm: 'ప్రాజెక్టులు', mnu_itm_url_tx: '/design-system/projects', mnu_itm_icn_tx: 'ri-folder-line' },
  //     { mnu_itm_nm: 'DB Relationships', t_mnu_itm_nm: 'DB సంబంధాలు', mnu_itm_url_tx: '/design-system/db-relationships', mnu_itm_icn_tx: 'ri-database-2-line' },
  //     { mnu_itm_nm: 'Form Builder', t_mnu_itm_nm: 'ఫారమ్ బిల్డర్', mnu_itm_url_tx: '/design-system/form-builder', mnu_itm_icn_tx: 'ri-file-list-3-line' },
  //     { mnu_itm_nm: 'Workflow Builder', t_mnu_itm_nm: 'వర్క్‌ఫ్లో బిల్డర్', mnu_itm_url_tx: '/design-system/workflow-builder', mnu_itm_icn_tx: 'ri-flow-chart-line' },
  //     { mnu_itm_nm: 'API Management', t_mnu_itm_nm: 'API నిర్వహణ', mnu_itm_url_tx: '/design-system/api-management', mnu_itm_icn_tx: 'ri-api-line' },
  //     { mnu_itm_nm: 'Connection Settings', t_mnu_itm_nm: 'కనెక్షన్ సెట్టింగ్‌లు', mnu_itm_url_tx: '/design-system/connection-settings', mnu_itm_icn_tx: 'ri-link-m' },
  //     { mnu_itm_nm: 'Themes', t_mnu_itm_nm: 'థీమ్‌లు', mnu_itm_url_tx: '/design-system/themes', mnu_itm_icn_tx: 'ri-brush-line' },
  //     { mnu_itm_nm: 'Templates', t_mnu_itm_nm: 'టెంప్లేట్‌లు', mnu_itm_url_tx: '/design-system/template-list', mnu_itm_icn_tx: 'ri-layout-line' },
  //     { mnu_itm_nm: 'PDF Editor', t_mnu_itm_nm: 'PDF ఎడిటర్', mnu_itm_url_tx: '/design-system/pdf-editor', mnu_itm_icn_tx: 'ri-file-pdf-line' }
  //   ]
  // },
  // { 
  //   mnu_itm_nm: 'Setup', 
  //   t_mnu_itm_nm: 'సెట్అప్',
  //   mnu_itm_url_tx: '/setup',
  //   mnu_itm_icn_tx: 'ri-settings-4-line',
  //   mnu_dscn_tx: 'System Setup & Configuration'
  // },
  // { 
  //   mnu_itm_nm: 'Help & Support', 
  //   t_mnu_itm_nm: 'సహాయం మరియు మద్దతు',
  //   mnu_itm_url_tx: '/help',
  //   mnu_itm_icn_tx: 'ri-question-line',
  //   mnu_dscn_tx: 'Help & Documentation'
  // },
  // { 
  //   mnu_itm_nm: 'Helpdesk', 
  //   t_mnu_itm_nm: 'హెల్ప్‌డెస్క్',
  //   mnu_itm_url_tx: '/helpdesk',
  //   mnu_itm_icn_tx: 'ri-customer-service-2-line',
  //   mnu_dscn_tx: 'Support Ticket Management'
  // }
];

// Hover styling for menu rows. Single source of truth — replaces the imperative
// setProperty blocks that were previously copy-pasted into every
// onMouseEnter/onMouseLeave handler below.
// Uses setProperty('important') because the base styles are inline, which a plain
// CSS :hover rule can't override.
//
// COLOURS COME FROM TOKENS, NOT LITERALS. These two used to write #1f2937 — a
// near-black — onto the row and its icon, which was correct back when the rail
// was a white surface. On the ink rail it painted near-black text and a
// near-black glyph onto a 5% white wash, so pointing at a row made its icon
// disappear. And because an INLINE !important outranks a stylesheet !important,
// nothing in the injected CSS could win it back; the label only survived because
// the stylesheet happened to target the inner <span> rather than the row.
//
// `variant`: 'row' (default) = transparent base; 'card' = bg-secondary base + link border.
type MenuHoverVariant = 'row' | 'card';

/*
 * Rows inside the rail's own <nav> get their hover from CSS (:hover rules in the
 * injected stylesheet). Writing it inline as well is what broke the selected
 * state: inline !important outranks every stylesheet rule, and the leave
 * handlers skip clearing a row that has just become current — so the pale hover
 * fill stayed stuck over the selected colour (and under its white text). Those
 * rows are left to CSS; the helpers below only paint the flyout/popup rows.
 */
const cssHandlesHover = (el: HTMLElement) => !!el.closest('.sidebar-container nav');

const applyMenuHover = (el: HTMLElement, variant: MenuHoverVariant = 'row') => {
  if (variant === 'row' && cssHandlesHover(el)) return;
  el.style.setProperty('background-color', 'var(--theme-sidemenu-hover)', 'important');
  el.style.setProperty('color', 'var(--theme-sidemenu-hover-fg)', 'important');
  el.style.setProperty('border-radius', 'var(--rail-radius)', 'important');
  // Stash the icon's original colour (which may be a per-item icn_clr_cd inline
  // colour) so leave can restore it exactly.
  const icon = el.querySelector('.sidebar-icon-inactive') as HTMLElement | null;
  if (icon) {
    icon.dataset.prevColor = icon.style.color || '';
    icon.style.setProperty('color', 'var(--theme-sidemenu-hover-fg)', 'important');
  }
  if (variant === 'card') {
    el.style.setProperty('border-color', 'var(--theme-sidemenu-marker)', 'important');
  }
};

const clearMenuHover = (el: HTMLElement, variant: MenuHoverVariant = 'row', restoreFg: string = 'var(--theme-sidemenu-fg)') => {
  if (variant === 'row' && cssHandlesHover(el)) {
    el.style.removeProperty('background-color');
    el.style.removeProperty('color');
    el.style.removeProperty('border-radius');
    return;
  }
  el.style.setProperty('background-color', variant === 'card' ? 'var(--theme-bg-secondary)' : 'transparent', 'important');
  el.style.setProperty('color', restoreFg, 'important');
  el.style.removeProperty('box-shadow');
  el.style.removeProperty('border-radius');
  const icon = el.querySelector('.sidebar-icon-inactive') as HTMLElement | null;
  if (icon) {
    const prev = icon.dataset.prevColor;
    if (prev) icon.style.setProperty('color', prev);
    else icon.style.removeProperty('color');
    delete icon.dataset.prevColor;
  }
  if (variant === 'card') {
    el.style.setProperty('border-color', 'var(--theme-sidemenu-glass-border)', 'important');
  }
};

/*
 * Dashboard is every user's landing page, but the auth-menu API returns it well
 * down the list, inside the General wing. These two helpers pin it to the very
 * top of the rail:
 *   - hoistDashboard moves it to the front of the top-level array (this alone is
 *     enough for tree view and search, which follow array order), and
 *   - the root list block renders it ABOVE the wing labels, because wings are
 *     ordered by wng_sqnce_id and General would otherwise drag it back down.
 * Matched by name so it keeps working when the menu row's id/url changes.
 */
const isDashboardItem = (item: any): boolean =>
  (item?.mnu_itm_nm || item?.prnt_mnu_itm_nm || '').toLowerCase().trim() === 'dashboard';

const isHeaderRow = (item: any): boolean =>
  item?.hdr_in === 1 || item?.hdr_in === true || item?.hdr_in === 't';

/*
 * Section wings: group a module's children by the section each child CARRIES,
 * instead of by the row that happens to sit above it.
 *
 * A section heading used to be an ordinary menu row with hdr_in = TRUE, a
 * SIBLING of the screens it headed, and groupByHeaders() below decided what
 * belonged under it purely by position. The Menu Profile admin screen grants a
 * screen with sqnce_id = MAX(sqnce_id) + 1, so anything granted after the fact
 * appended past the LAST heading: on role 528 (UDA Engineer 1) ten WMS screens —
 * Measurements, Check Measurements, Quality Control, Bills & Payments, GIS
 * Mapping, Sachivalayam Mapping, Bank Guarantees, Mobilization Advance,
 * Penalties, Setup — all read as "Configuration", while Progress and Payments
 * showed nearly empty. Nothing was wrong with the grants; only the order was.
 *
 * The section now travels on the row (app_mnu_itm_lst_t.wng_id -> sctn_wng_*),
 * so where a screen appears no longer depends on its neighbours.
 *
 * The output stays FLAT — captions are emitted as synthetic hdr_in siblings, the
 * same shape the API used to send — because the three render paths consume that
 * shape and one of them (the flyout list, ~line 1857) maps children flatly and
 * would drop anything nested under a heading.
 *
 * Modules whose children carry no section are returned untouched, so this is
 * inert everywhere except WMS (NEW).
 */
const applySectionWings = (items: any): any => {
  if (!Array.isArray(items)) return items;

  return items.map((item: any) => {
    const kids: any[] = Array.isArray(item?.children) ? item.children : [];
    if (kids.length === 0) return item;

    const nested = applySectionWings(kids);
    const hasSections = nested.some((k: any) => k?.sctn_wng_id !== null && k?.sctn_wng_id !== undefined && k?.sctn_wng_id !== '');
    if (!hasSections) return { ...item, children: nested };

    const loose: any[] = [];
    const order: string[] = [];
    const sections = new Map<string, { seq: number; header: any; children: any[] }>();

    nested.forEach((kid: any) => {
      // The legacy hdr_in rows are the pre-wing captions for these same sections.
      // They are still active in the DB and still granted on every profile, so
      // they are dropped here rather than being deactivated — leaving them in
      // would print each caption twice.
      if (isHeaderRow(kid)) return;

      const key = kid?.sctn_wng_id === null || kid?.sctn_wng_id === undefined || kid?.sctn_wng_id === ''
        ? null
        : String(kid.sctn_wng_id);

      // No section = sits above the first heading (Dashboard, Workflow Inbox …).
      if (key === null) { loose.push(kid); return; }

      let group = sections.get(key);
      if (!group) {
        const seq = Number(kid.sctn_wng_sqnce_id);
        group = {
          seq: Number.isFinite(seq) ? seq : 999,
          header: {
            mnu_itm_id: `sctn-${key}`,
            mnu_itm_nm: kid.sctn_wng_nm || '',
            t_mnu_itm_nm: kid.sctn_t_wng_nm,
            mnu_itm_url_tx: '',
            mnu_itm_icn_tx: kid.sctn_wng_icn_tx,
            mnu_itm_icn_clr_cd: kid.sctn_wng_icn_clr_cd,
            // The collapsed rail reads the prnt_* icon fields on a header row.
            prnt_mnu_icn_tx: kid.sctn_wng_icn_tx,
            prnt_mnu_icn_clr_cd: kid.sctn_wng_icn_clr_cd,
            prnt_mnu_itm_id: kid.prnt_mnu_itm_id,
            hdr_in: true,
          },
          children: [],
        };
        sections.set(key, group);
        order.push(key);
      }
      group.children.push(kid);
    });

    // Wing sequence decides the order of the sections; first-seen order breaks a
    // tie so two sections sharing a sqnce_id cannot swap between renders.
    const ordered = order
      .map((key, idx) => ({ key, idx, ...(sections.get(key) as any) }))
      .sort((a, b) => (a.seq - b.seq) || (a.idx - b.idx));

    const flat: any[] = [...loose];
    ordered.forEach((g) => { flat.push(g.header, ...g.children); });

    return { ...item, children: flat };
  });
};

/**
 * The live menu node matching a captured one — same URL, else same name.
 *
 * Used to keep a pinned/drilled-into frame in step with the tree it came from:
 * the stack holds a copy, and a copy cannot see a label the tree grew later.
 * URL first because names are decorated (the Inbox carries its "(N)") while the
 * URL never changes.
 */
const findLiveMenuNode = (items: any[], target: any): any | null => {
  const url = target?.mnu_itm_url_tx || target?.prnt_mnu_itm_url_tx || '';
  const name = target?.mnu_itm_nm || target?.prnt_mnu_itm_nm || '';
  if (!url && !name) return null;

  const walk = (list: any[]): any | null => {
    for (const item of list || []) {
      const itemUrl = item?.mnu_itm_url_tx || item?.prnt_mnu_itm_url_tx || '';
      const itemName = item?.mnu_itm_nm || item?.prnt_mnu_itm_nm || '';
      if (url ? itemUrl === url : itemName === name) return item;
      if (Array.isArray(item?.children) && item.children.length) {
        const found = walk(item.children);
        if (found) return found;
      }
    }
    return null;
  };
  return walk(items);
};

const hoistDashboard = (items: any): any => {
  if (!Array.isArray(items)) return items;
  const idx = items.findIndex(isDashboardItem);
  if (idx <= 0) return items;
  const rest = items.slice();
  const [dashboard] = rest.splice(idx, 1);
  return [dashboard, ...rest];
};

const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  onToggle,
  isCollapsed,
  onToggleCollapse,
  menuItems = defaultNavItems
}) => {
  const { authType } = useAuth();
  /* useTheme() is still called for the context subscription — it is what
     re-renders the rail when the theme flips — but nothing here reads isDark any
     more. Every light/dark difference now lives in the --theme-sidemenu-*
     tokens, which is the point: the rail does not branch on a boolean, it reads
     a colour. (The last isDark branch was in the dead view-mode toggle.) */
  useTheme();
  const location = useLocation();

  // Palette-coloured scrollbars app-wide (see index.css `home-gold-scroll`), the
  // Finance modules included — except Easy Entry Mode, which keeps its own teal.
  const ownScroll = /\/finance2\/tally-entry\/?$/.test(location.pathname);
  useEffect(() => {
    if (ownScroll) return undefined;
    const root = document.documentElement;
    root.classList.add('home-gold-scroll');
    return () => root.classList.remove('home-gold-scroll');
  }, [ownScroll]);

  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const [hoveredMenuPosition, setHoveredMenuPosition] = useState({ x: 0, y: 0 });
  // The menu search field lives in the top header now; both read the shared store.
  const searchTerm = useSidebarStore(state => state.searchTerm);
  const setSearchTerm = useSidebarStore(state => state.setSearchTerm);
  // The rail's own node, so the sub-module flyout can open flush against its right edge.
  const asideRef = useRef<HTMLElement | null>(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [secondarySidebar, setSecondarySidebar] = useState<{ item: any | null, isOpen: boolean, openedByClick: boolean }>({ item: null, isOpen: false, openedByClick: false });
  const [secondarySidebarSearch, setSecondarySidebarSearch] = useState('');
  // Vertical anchor (viewport px) for the sub-module flyout, so it opens beside the
  // clicked/hovered module and sizes to its content instead of taking the full height.
  const [secondaryAnchorTop, setSecondaryAnchorTop] = useState<number | null>(null);
  const [currentActivePath, setCurrentActivePath] = useState(location.pathname);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const searchTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const secondarySidebarTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Top of the module list, so the flyout opens where the module names start.
  const menuNavRef = useRef<HTMLElement | null>(null);
  const [apiMenuItems, setApiMenuItems] = useState<any[]>([]);
  const [isMenuLoading, setIsMenuLoading] = useState(true);

  // Persisted view mode state
  const [viewMode, setViewMode] = useState<'list' | 'tree'>(() => {
    const saved = localStorage.getItem('sidebarViewMode');
    return (saved === 'tree' || saved === 'list') ? saved : 'list';
  });

  const [expandedTreeNodes, setExpandedTreeNodes] = useState<Set<string>>(() => {
    try {
      // Check version to handle nodeId format change (added index to nodeId)
      const version = localStorage.getItem('sidebarExpandedNodesVersion');
      if (version !== '2') {
        // Clear old format and set new version
        localStorage.removeItem('sidebarExpandedNodes');
        localStorage.setItem('sidebarExpandedNodesVersion', '2');
        return new Set();
      }
      const saved = localStorage.getItem('sidebarExpandedNodes');
      return saved ? new Set(JSON.parse(saved)) : new Set();
    } catch {
      return new Set();
    }
  });

  // Wings (grandparent tier) render as static section labels — flanked by hairlines,
  // not collapsible, no state to track.

  // Drill-down navigation state - store URLs for persistence
  const [drillDownStack, setDrillDownStack] = useState<any[]>([]);
  const [drillDownUrls, setDrillDownUrls] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem('sidebarDrillDownUrls');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  // The frame the officer drilled into, as it was CAPTURED. Read the live
  // re-resolution below (`currentDrillDownItem`) rather than this — see the note
  // there for why the difference matters.
  const drilledSnapshot = drillDownStack.length > 0 ? drillDownStack[drillDownStack.length - 1] : null;

  // Save viewMode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('sidebarViewMode', viewMode);
  }, [viewMode]);

  // Save expandedTreeNodes to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('sidebarExpandedNodes', JSON.stringify([...expandedTreeNodes]));
  }, [expandedTreeNodes]);

  // Track if initial restore is complete before allowing saves
  const drillDownInitializedRef = useRef(false);

  // Save drillDownIdentifiers to localStorage when it changes (use URL or name for items without URLs)
  // Only save after initial restore is complete to avoid clearing saved state
  useEffect(() => {
    // Skip saving on initial mount - wait for restore to complete first
    if (!drillDownInitializedRef.current) {
      return;
    }

    // Build path-based identifiers for uniqueness
    // For each item in the stack, include parent names to create a unique path
    const identifiers = drillDownStack.map((item, index) => {
      const url = item.mnu_itm_url_tx || item.prnt_mnu_itm_url_tx;
      const name = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';

      if (url) {
        return url;
      }

      // For items without URL, create a path-based identifier including parent names
      const pathParts = drillDownStack.slice(0, index + 1).map(i => i.mnu_itm_nm || i.prnt_mnu_itm_nm || '');
      const identifier = `path:${pathParts.join('/')}`;
      // console.log('Saving drill-down item:', { name, url, identifier, pathParts });
      return identifier;
    });
    // console.log('Saving drill-down identifiers to localStorage:', identifiers);
    setDrillDownUrls(identifiers);
    localStorage.setItem('sidebarDrillDownUrls', JSON.stringify(identifiers));
  }, [drillDownStack]);

  // API function to fetch auth menu
  const fetchAuthMenu = async () => {
    setIsMenuLoading(true);
    try {
      // Use apufidc-auth for APUFIDC users (fetches from apufidc_enc_db schema)
      const authEndpoint = authType === 'crda' ? 'crda-auth' : authType === 'apufidc' ? 'apufidc-auth' : 'erp-auth';
      const response = await baseAPIService.get(`${authEndpoint}/menu`);
      // console.log('Auth menu data:', response.data);
      // API returns {status, message, data: [...]} so we need response.data.data
      const menuData = Array.isArray(response.data?.data) ? response.data.data : [];
      setApiMenuItems(menuData);
      return menuData;
    } catch (error) {
      console.error('Error fetching auth menu:', error);
      setApiMenuItems([]);
      return [];
    } finally {
      setIsMenuLoading(false);
    }
  };

  // Skeleton Loading Component for Menu Items
  const MenuSkeleton = () => {
    // Deterministic, varied widths — avoids Math.random() in render, which would
    // re-roll the bar widths on every re-render and cause visible layout jitter.
    const skeletonWidths = ['78%', '64%', '85%', '58%', '72%', '90%', '66%', '80%'];

    return (
      <div className={`${isCollapsed ? 'px-1' : 'px-1'} animate-pulse`}>
        {skeletonWidths.map((width, index) => (
          <div key={index} className="relative mb-1">
            <div
              className={`flex items-center transition-all duration-200 ${isCollapsed ? 'justify-center p-1.5' : 'px-3 py-1.5'
                }`}
            >
              {/* Icon skeleton */}
              {/* Sized and coloured like the real thing: a 20px bar where the
                  icon goes, in the rail's own glass rather than the content
                  area's light-grey border token — a pale disc on the ink was
                  a louder placeholder than the menu it stood in for. */}
              <div
                className={`w-5 h-5 rounded ${isCollapsed ? 'mx-auto' : 'mr-2.5'}`}
                style={{ backgroundColor: 'var(--theme-sidemenu-glass)' }}
              />
              {/* Text skeleton - only show when not collapsed */}
              {!isCollapsed && (
                <div className="flex-1">
                  <div
                    className="h-3 rounded"
                    style={{
                      backgroundColor: 'var(--theme-sidemenu-glass)',
                      width
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Fetch auth menu on component mount
  useEffect(() => {
    fetchAuthMenu();
  }, []);

  // The effect that opens the group holding the current route lives further
  // down, next to `mergedMenuItems` — it has to read that list, and a
  // dependency array is evaluated during render, so it cannot sit above it.

  const toggleExpanded = (path: string) => {
    // On mobile (< 1024px), always allow submenu toggle regardless of isCollapsed state
    const isMobile = window.innerWidth < 1024;
    if (isCollapsed && !isMobile) return;

    // Accordion: opening a module closes any other currently-expanded module
    // (only one submenu open at a time).
    setExpandedItems(prev =>
      prev.includes(path)
        ? prev.filter(item => item !== path)
        : [path]
    );
  };

  const isExpanded = (path: string) => expandedItems.includes(path);

  /**
   * Is this string a real route, or one of the two placeholders the menu data uses
   * where a row has no page of its own?
   *
   *  - `''`     — a synthetic section caption (applySectionWings writes an empty url).
   *  - `'/app'` — ANY row whose url_tx is blank, plus every top-level row's
   *                `prnt_mnu_itm_url_tx`: the menu query builds both as
   *                `'/app' || COALESCE(url_tx, '')`, so a missing url collapses to the
   *                app root itself.
   *
   * Both used to reach isActive, where `pathname.startsWith(path + '/')` turned them
   * into a prefix of EVERY page in the app. That is what made a module with section
   * captions (WMS (NEW), Scheme & Permission Applications) report an active sub-item
   * on every route and therefore open itself on load, on refresh, and while the reader
   * was somewhere else entirely.
   */
  const isRoutePath = (path?: string | null): path is string => {
    const p = (path || '').trim();
    return !!p && p !== '/' && p !== '/app' && p !== '/app/';
  };

  /**
   * The path a module row is keyed and matched by: its parent url when that is a real
   * route (a group), otherwise its own (a leaf granted directly at the root, whose
   * prnt_mnu_itm_url_tx is the bare '/app'). Used for the expansion key AND the active
   * check, which must agree or a group opens under a key nothing looks up.
   */
  const menuPath = (item: any): string =>
    (isRoutePath(item?.prnt_mnu_itm_url_tx) ? item.prnt_mnu_itm_url_tx : item?.mnu_itm_url_tx) || '';

  const isActive = (path?: string | null) =>
    isRoutePath(path) && (location.pathname === path || location.pathname.startsWith(path + '/'));

  /**
   * Menu rows normally highlight on an EXACT url match (every sub-item NavLink below
   * carries `end`). That holds only while a menu row and its screen share one url, and
   * Display Devices breaks the assumption in three ways:
   *
   *   - Enforcement points at /display-devices/compliance, and CompliancePage
   *     immediately redirects to /compliance/notices — so the row lost its highlight
   *     the instant it was clicked, which is the reported bug.
   *   - Setup and Reports own whole sub-trees (/setup/tariff, /reports/42).
   *   - Displayers and Devices open detail pages (/devices/7/edit).
   *
   * In each case the reader is still inside the section the row names, so the row must
   * stay lit. These two helpers switch such rows to a prefix match.
   *
   * Scope: ONLY urls inside the Display Devices module. Every other module keeps the
   * exact-match behaviour it has today — a prefix match applied app-wide would light up
   * unrelated rows wherever one menu url happens to be a parent of another.
   *
   * The module root itself (/app/maud-erp/display-devices, the Dashboard row) is
   * deliberately excluded by the trailing slash: it is a prefix of every page in the
   * module, so a prefix match would light Dashboard on all of them.
   */
  const DD_MODULE_ROOT = '/app/maud-erp/display-devices';
  const matchesBySubTree = (path?: string | null): path is string =>
    isRoutePath(path) && path.startsWith(DD_MODULE_ROOT + '/');

  /** Exact match, plus a sub-tree match for the Display Devices rows described above. */
  const isRowActive = (path?: string | null) =>
    isRoutePath(path) &&
    (location.pathname === path ||
      (matchesBySubTree(path) && location.pathname.startsWith(path + '/')));
  // Recurses, because the auth-menu API nests groups more than one level deep.
  // Testing only the immediate children left a route that sits under a
  // sub-group invisible to the auto-expand below.
  const hasActiveSubItem = (children?: SubItem[]): boolean => {
    if (!children) return false;
    return children.some((child: any) =>
      // A section caption is a label, never a destination — it cannot be the reason a
      // module counts as open. isActive already rejects its empty url; this says so.
      !isHeaderRow(child) &&
      (isActive(child.mnu_itm_url_tx) || hasActiveSubItem(child.children)));
  };

  // Helper function to create a lighter version of a hex color for icon backgrounds
  const getLighterColor = (hexColor: string | undefined, opacity: number = 0.15): string | undefined => {
    if (!hexColor) return undefined;
    // Convert hex to rgba with low opacity for a lighter effect
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const handleMenuItemHover = (item: any, event: React.MouseEvent) => {
    // Prefetch the hovered module's lazy route chunk so it opens instantly on click.
    prefetchRoute(menuPath(item));
    // Skip hover handling on mobile - use click only
    const isMobile = window.innerWidth < 1024;
    if (isMobile) return;

    // Clear any existing timeouts
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    if (secondarySidebarTimeoutRef.current) {
      clearTimeout(secondarySidebarTimeoutRef.current);
      secondarySidebarTimeoutRef.current = null;
    }

    // When the rail is collapsed (minimized) we no longer show any hover flyout/popup.
    // Sub-modules are reached by clicking the module, which expands the rail and opens it
    // inline (see handleParentMenuClick). So hovering does nothing in collapsed mode.
    if (isCollapsed) return;

    // Hovered item doesn't have its own secondary sidebar, but one from a previous
    // hover is still open — close it (unless user clicked to pin it open).
    // Without this the old flyout stays visible while the user is on an unrelated item.
    if (secondarySidebar.isOpen && !secondarySidebar.openedByClick) {
      secondarySidebarTimeoutRef.current = setTimeout(() => {
        setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
        setSecondarySidebarSearch('');
      }, 150);
    }
  };

  const handleMenuItemLeave = () => {
    if (isCollapsed) {
      // Handle popup menu leave for collapsed sidebar
      hoverTimeoutRef.current = setTimeout(() => {
        setHoveredItem(null);
      }, 150);

      // Also handle secondary sidebar auto-close for collapsed state (only for hover-opened sidebars)
      if (!secondarySidebar.openedByClick && secondarySidebar.isOpen) {
        secondarySidebarTimeoutRef.current = setTimeout(() => {
          setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
          setSecondarySidebarSearch('');
        }, 150);
      }
    } else {
      // Handle secondary sidebar auto-close on hover out when expanded (only for hover-opened sidebars)
      if (!secondarySidebar.openedByClick && secondarySidebar.isOpen) {
        secondarySidebarTimeoutRef.current = setTimeout(() => {
          setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
          setSecondarySidebarSearch('');
        }, 150);
      }
    }
  };

  const handlePopupEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  };

  const handlePopupLeave = () => {
    setHoveredItem(null);
  };

  const handleSecondarySidebarEnter = () => {
    if (secondarySidebarTimeoutRef.current) {
      clearTimeout(secondarySidebarTimeoutRef.current);
      secondarySidebarTimeoutRef.current = null;
    }
  };

  const handleSecondarySidebarLeave = () => {
    // Only auto-close if sidebar was opened by hover (not by click)
    if (!secondarySidebar.openedByClick && secondarySidebar.isOpen) {
      secondarySidebarTimeoutRef.current = setTimeout(() => {
        setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
        setSecondarySidebarSearch('');
      }, 200);
    }
  };

  // Track previous search term to detect when search is cleared (not on initial load)
  const prevSearchTermRef = useRef<string>('');

  // Debounced search effect
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      // Only reset view mode when search was active and is now cleared (not on initial load)
      if (!searchTerm.trim() && prevSearchTermRef.current.trim()) {
        // Search was cleared - restore saved view mode from localStorage
        const savedViewMode = localStorage.getItem('sidebarViewMode');
        if (savedViewMode === 'tree' || savedViewMode === 'list') {
          setViewMode(savedViewMode);
        }
      }
      prevSearchTermRef.current = searchTerm;
    }, 300);

    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [searchTerm]);

  // Merge: use API menu items as base, but override children with hardcoded
  // children from menuItems prop when defined (enables frontend-driven grouping)
  const baseMergedMenuItems = React.useMemo(() => {
    if (apiMenuItems.length === 0) return hoistDashboard(menuItems);
    // Sections are resolved before the overrides run: a module whose children are
    // hardcoded in the menuItems prop replaces them wholesale below, and those
    // carry no sctn_wng_* — so grouping them first would be work thrown away, and
    // grouping after would run over the override and find nothing to group.
    if (!menuItems || menuItems.length === 0) return hoistDashboard(applySectionWings(apiMenuItems));

    // Build a lookup of hardcoded items that have children overrides, keyed by name
    const overrideMap = new Map<string, any[]>();
    menuItems.forEach((item: any) => {
      if (item.children && item.children.length > 0) {
        const name = (item.mnu_itm_nm || '').toLowerCase().trim();
        if (name) overrideMap.set(name, item.children);
      }
    });

    // Walk API items and replace children where hardcoded overrides exist
    const applyOverrides = (items: any[]): any[] =>
      items.map((item: any) => {
        // API parent items use prnt_mnu_itm_nm; leaf items use mnu_itm_nm
        const name = (item.mnu_itm_nm || item.prnt_mnu_itm_nm || '').toLowerCase().trim();
        const override = overrideMap.get(name);
        if (override) {
          return { ...item, children: [...override] };
        }
        if (item.children && item.children.length > 0) {
          return { ...item, children: applyOverrides(item.children) };
        }
        return item;
      });

    const result = applyOverrides(applySectionWings(apiMenuItems));

    return hoistDashboard(result);
  }, [apiMenuItems, menuItems]);

  /*
   * "Inbox (N)" on the Display Devices Inbox row.
   *
   * Wired here, on the one Sidebar every shell renders (components/Layout and
   * MaudErpLayoutWrapper both mount this component), so the number is there on
   * every login rather than only on the shells that remembered to fold it in.
   * It decorates `baseMergedMenuItems` — i.e. after the API tree and the
   * hardcoded overrides have been merged — so the row matches whichever of the
   * two supplied it. A user with no Display Devices Inbox gets the tree back
   * untouched and fires no request.
   */
  const mergedMenuItems: any[] = useDisplayDevicesInboxBadge<any>(baseMergedMenuItems);

  /*
   * Open the group the current route sits in.
   *
   * A page reached by URL rather than by click — a reload, a bookmark, a link
   * someone was sent — used to arrive with the whole rail folded and nothing
   * marked, so the menu could not say where you were. Clicking in was the only
   * way to make it say so, which is the one case where you already knew.
   *
   * It walks `mergedMenuItems`, not the `menuItems` prop. Nearly every group
   * draws its children from the auth-menu API and only a handful are overridden
   * in the frontend list, so walking the prop skipped every API-driven group.
   * Finance is one: its hardcoded entry carries no children at all, which is
   * why landing on a finance2 page left the rail shut while Display Devices,
   * whose children ARE hardcoded, opened correctly.
   *
   * The key matches what the row and its click handler use — API parents are
   * keyed by `prnt_mnu_itm_url_tx`, hardcoded ones by `mnu_itm_url_tx` — or
   * this would write an entry `isExpanded` never looks up.
   *
   * On a NAVIGATION it replaces, so the rail holds the accordion's one-open-group
   * rule: moving from one module to another closes the one you left instead of
   * stacking every module you have visited. On any OTHER run — collapsing the rail
   * and reopening it, or the menu arriving from the API — it only adds, because
   * replacing there would pull a group the reader had just opened by hand shut
   * again. Landing on a module with no group of its own (a root-level screen)
   * leaves what is open alone rather than blanking the rail.
   */
  const lastExpandPathname = useRef<string | null>(null);
  useEffect(() => {
    // On mobile (< 1024px), don't clear expanded items when collapsed
    const isMobile = window.innerWidth < 1024;

    if (!isCollapsed || isMobile) {
      const navigated = lastExpandPathname.current !== location.pathname;
      lastExpandPathname.current = location.pathname;

      const keys = (Array.isArray(mergedMenuItems) ? mergedMenuItems : [])
        .filter((item: any) => item.children?.length && hasActiveSubItem(item.children))
        .map((item: any) => menuPath(item))
        .filter(Boolean);

      if (navigated) {
        if (keys.length > 0) setExpandedItems(keys);
        return;
      }
      keys.forEach((key: string) => {
        setExpandedItems(prev => prev.includes(key) ? prev : [...prev, key]);
      });
    } else {
      lastExpandPathname.current = null;
      setExpandedItems([]);
      setSearchTerm(''); // Clear search when collapsed
    }
  }, [location.pathname, isCollapsed, mergedMenuItems]);

  // Filter menu items based on debounced search term
  // Note: APUFIDC filtering is now done server-side via ?app=apufidc query param
  const filteredMenuItems =
    (Array.isArray(mergedMenuItems) ? mergedMenuItems : []).filter(item => {
      if (!debouncedSearchTerm) return true;

      const searchLower = debouncedSearchTerm.toLowerCase();
      const itemName = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';
      const matchesLabel = itemName.toLowerCase().includes(searchLower);
      const matchesSubItems = item.children?.some((child: any) => {
        const childName = child.mnu_itm_nm || '';
        return childName.toLowerCase().includes(searchLower);
      });

      return matchesLabel || matchesSubItems;
    });

  // Group items by header (hdr_in=1 becomes parent, following items become children)
  // Group top-level modules under their wing (the grandparent tier).
  // Order is wing sequence first, then the module order the API already applied.
  // Modules arriving without a wing are bucketed into the catch-all so nothing is
  // ever dropped from the sidebar — the API normally resolves this to 'General'.
  const groupByWings = (items: any[]): WingGroup[] => {
    const byWing = new Map<string, WingGroup>();

    items.forEach(item => {
      const wingId = String(item?.wng_id ?? '__none__');
      let group = byWing.get(wingId);
      if (!group) {
        const seq = Number(item?.wng_sqnce_id);
        group = {
          wng_id: wingId,
          wng_cd: item?.wng_cd,
          wng_nm: item?.wng_nm || 'General',
          t_wng_nm: item?.t_wng_nm,
          wng_icn_tx: item?.wng_icn_tx,
          wng_icn_clr_cd: item?.wng_icn_clr_cd,
          wng_sqnce_id: Number.isFinite(seq) ? seq : 999,
          items: [],
        };
        byWing.set(wingId, group);
      }
      group.items.push(item);
    });

    return Array.from(byWing.values()).sort((a, b) => a.wng_sqnce_id - b.wng_sqnce_id);
  };

  const groupByHeaders = (items: any[]): any[] => {
    const result: any[] = [];
    let currentHeader: any = null;

    items.forEach(item => {
      const isHeader = item.hdr_in === 1 || item.hdr_in === true || item.hdr_in === 't' ||
        item.prnt_hdr_in === 1 || item.prnt_hdr_in === true || item.prnt_hdr_in === 't';

      if (isHeader) {
        // If there's a previous header, add it to results
        if (currentHeader) {
          result.push(currentHeader);
        }
        // Start new header group - this becomes the parent
        currentHeader = {
          ...item,
          children: item.children ? [...item.children] : []
        };
      } else if (currentHeader) {
        // Add as child of current header
        currentHeader.children.push(item);
      } else {
        // No header yet, add as top-level item
        result.push(item);
      }
    });

    // Don't forget the last header group
    if (currentHeader) {
      result.push(currentHeader);
    }

    // Recursively process children that might also have headers
    return result.map(item => ({
      ...item,
      children: item.children && item.children.length > 0
        ? groupByHeaders(item.children)
        : undefined
    }));
  };

  // Build tree structure from menu items (preserving hierarchy)
  const buildTreeStructure = (items: any[]): any[] => {
    // First, group items by headers
    const groupedItems = groupByHeaders(items);

    if (!debouncedSearchTerm) {
      // If no search, return grouped items with their children recursively
      return groupedItems.map(item => ({
        ...item,
        children: item.children && item.children.length > 0
          ? buildTreeStructure(item.children)
          : undefined
      }));
    }

    // When searching, preserve parent-child relationships and show matching items
    const searchLower = debouncedSearchTerm.toLowerCase();

    const processItem = (item: any): any | null => {
      const itemName = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';
      const matchesLabel = itemName.toLowerCase().includes(searchLower);

      // Process children recursively
      let processedChildren: any[] = [];
      if (item.children && item.children.length > 0) {
        processedChildren = item.children
          .map(processItem)
          .filter((child: any) => child !== null);
      }

      // Include item if:
      // 1. The item itself matches the search, OR
      // 2. It has matching children (so we can show the parent to access children)
      if (matchesLabel || processedChildren.length > 0) {
        return {
          ...item,
          children: processedChildren.length > 0 ? processedChildren : undefined
        };
      }

      return null;
    };

    return groupedItems
      .map(processItem)
      .filter((item: any) => item !== null);
  };

  const treeStructure = buildTreeStructure(mergedMenuItems);

  /*
   * What the pinned (drilled-into) rail actually renders.
   *
   * `drillDownStack` stores SNAPSHOTS — the node object as it was when the
   * officer clicked into the module, and the same when the stack is restored
   * from localStorage on a reload. Anything that changes a label afterwards
   * therefore never reaches the pinned view, because it changes the live tree
   * and the snapshot is a copy. That is what dropped the Display Devices Inbox
   * badge: the count arrives a moment after the menu, so a pinned rail showed
   * "Inbox" with no number for the rest of the session, while the un-pinned rail
   * showed "Inbox (1)" correctly.
   *
   * So re-resolve the top frame against the live tree on every render, by URL
   * (stable) and falling back to name. A frame that can no longer be found —
   * a menu that changed under a pinned module — keeps rendering its snapshot
   * rather than collapsing the rail to nothing.
   */
  const currentDrillDownItem = React.useMemo(
    () => (drilledSnapshot ? (findLiveMenuNode(treeStructure, drilledSnapshot) || drilledSnapshot) : null),
    [drilledSnapshot, treeStructure],
  );

  // Restore drill-down stack from saved identifiers when menu data loads
  useEffect(() => {
    // Only run once when tree structure is loaded AND API data is available
    if (treeStructure.length === 0 || isMenuLoading) {
      // console.log('Drill-down restore skipped - waiting for data:', {
      //   treeStructureLength: treeStructure.length,
      //   isMenuLoading
      // });
      return;
    }

    // console.log('Drill-down restore check:', {
    //   treeStructureLength: treeStructure.length,
    //   drillDownUrlsLength: drillDownUrls.length,
    //   drillDownInitialized: drillDownInitializedRef.current,
    //   drillDownUrls,
    //   apiMenuItemsLength: apiMenuItems.length
    // });

    // If already initialized, don't restore again
    if (drillDownInitializedRef.current) {
      return;
    }

    // Mark as initialized - this allows the save useEffect to start working
    drillDownInitializedRef.current = true;

    // If there are no saved URLs, nothing to restore
    if (drillDownUrls.length === 0) {
      // console.log('No saved drill-down state to restore');
      return;
    }

    // Find item by URL in tree structure
    const findItemByUrl = (items: any[], url: string): any | null => {
      for (const item of items) {
        const itemUrl = item.mnu_itm_url_tx || item.prnt_mnu_itm_url_tx;
        if (itemUrl === url) {
          return item;
        }
        if (item.children && item.children.length > 0) {
          const found = findItemByUrl(item.children, url);
          if (found) return found;
        }
      }
      return null;
    };

    // Find item by path - navigate through the tree following the path
    const findItemByPath = (items: any[], pathParts: string[]): any | null => {
      if (pathParts.length === 0) return null;

      const targetName = pathParts[0];
      for (const item of items) {
        const itemName = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';
        if (itemName === targetName) {
          if (pathParts.length === 1) {
            // This is the target item
            return item;
          } else if (item.children && item.children.length > 0) {
            // Continue down the path
            return findItemByPath(item.children, pathParts.slice(1));
          }
        }
      }
      return null;
    };

    // Rebuild the drill-down stack from identifiers
    const restoredStack: any[] = [];
    for (const identifier of drillDownUrls) {
      if (identifier) {
        // console.log('Looking for identifier:', identifier);
        let item: any = null;

        if (identifier.startsWith('path:')) {
          // Path-based identifier - navigate through the tree
          const pathStr = identifier.substring(5);
          const pathParts = pathStr.split('/');
          item = findItemByPath(treeStructure, pathParts);
          // console.log('Path search:', { pathParts, found: item ? (item.mnu_itm_nm || item.prnt_mnu_itm_nm) : 'NOT FOUND' });
        } else if (identifier.startsWith('name:')) {
          // Legacy name-based identifier - search by name only (for backwards compatibility)
          const name = identifier.substring(5);
          const findByName = (items: any[]): any | null => {
            for (const i of items) {
              if ((i.mnu_itm_nm || i.prnt_mnu_itm_nm) === name) return i;
              if (i.children) {
                const found = findByName(i.children);
                if (found) return found;
              }
            }
            return null;
          };
          item = findByName(treeStructure);
        } else {
          // URL-based identifier
          item = findItemByUrl(treeStructure, identifier);
        }

        // console.log('Found item:', item ? (item.mnu_itm_nm || item.prnt_mnu_itm_nm) : 'NOT FOUND');
        // console.log('Item children:', item?.children?.length || 0, 'children');
        if (item) {
          restoredStack.push(item);
        }
      }
    }

    if (restoredStack.length > 0) {
      // console.log('Restored drill-down stack:', restoredStack.map(i => i.mnu_itm_nm || i.prnt_mnu_itm_nm));
      setDrillDownStack(restoredStack);
    }
  }, [treeStructure, drillDownUrls]);

  // Toggle tree node expansion
  const toggleTreeNode = (nodeId: string) => {
    // console.log('Toggle tree node:', nodeId);
    setExpandedTreeNodes(prev => {
      const newSet = new Set(prev);
      const wasExpanded = newSet.has(nodeId);
      if (wasExpanded) {
        newSet.delete(nodeId);
      } else {
        newSet.add(nodeId);
      }
      // console.log('Node expanded state changed:', nodeId, 'from', wasExpanded, 'to', !wasExpanded);
      // console.log('Expanded nodes:', [...newSet]);
      return newSet;
    });
  };

  // Check if tree node is expanded
  const isTreeNodeExpanded = (nodeId: string) => expandedTreeNodes.has(nodeId);

  // Check if node has children (leaf node check)
  const hasChildren = (item: any) => {
    return item.children && Array.isArray(item.children) && item.children.length > 0;
  };

  // Track if initial expansion has been done (to avoid overwriting saved state)
  const initialExpansionDone = useRef(false);

  // Auto-expand tree nodes when searching, or expand top-level nodes on first load only
  useEffect(() => {
    if (viewMode === 'tree' && treeStructure.length > 0) {
      if (debouncedSearchTerm) {
        // When searching, expand nodes that match
        const expandMatchingNodes = (items: any[], level: number = 0) => {
          items.forEach((item, index) => {
            const itemUrl = item.mnu_itm_url_tx || item.prnt_mnu_itm_url_tx;
            const nodeId = itemUrl || `node-${item.mnu_itm_nm || item.prnt_mnu_itm_nm || 'item'}-${level}-${index}`;
            const itemName = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';
            const searchLower = debouncedSearchTerm.toLowerCase();
            const matchesLabel = itemName.toLowerCase().includes(searchLower);

            if (matchesLabel || hasChildren(item)) {
              setExpandedTreeNodes(prev => new Set([...prev, nodeId]));
            }

            if (item.children && item.children.length > 0) {
              expandMatchingNodes(item.children, level + 1);
            }
          });
        };
        expandMatchingNodes(treeStructure);
      } else if (!initialExpansionDone.current && expandedTreeNodes.size === 0) {
        // Only auto-expand top-level nodes on first load if no saved state exists
        initialExpansionDone.current = true;
        const expandTopLevel = (items: any[]) => {
          items.forEach((item, index) => {
            const itemUrl = item.mnu_itm_url_tx || item.prnt_mnu_itm_url_tx;
            const nodeId = itemUrl || `node-${item.mnu_itm_nm || item.prnt_mnu_itm_nm || 'item'}-0-${index}`;
            if (hasChildren(item)) {
              setExpandedTreeNodes(prev => new Set([...prev, nodeId]));
            }
          });
        };
        expandTopLevel(treeStructure);
      }
    }
  }, [debouncedSearchTerm, viewMode, treeStructure]);

  // Ctrl/Cmd + K focuses the menu search at the top of the rail, expanding a
  // collapsed rail first (the field only exists on the expanded rail).
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        if (isCollapsed && window.innerWidth >= 1024) {
          onToggleCollapse();
          setTimeout(() => searchInputRef.current?.focus(), 320);
        } else {
          searchInputRef.current?.focus();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isCollapsed, onToggleCollapse]);

  const handlePopupItemClick = () => {
    setHoveredItem(null);

    if (window.innerWidth < 1024) {
      onClose();
    }
  };

  const handleMenuItemClick = () => {
    if (window.innerWidth < 1024) {
      onClose();
    }
  };

  // Handle submenu item click - ensure it stays minimized
  const handleSubmenuItemClick = (parentPath: string) => {
    // If we're in collapsed mode, keep submenus collapsed
    if (isCollapsed) {
      setExpandedItems(prev => prev.filter(item => item !== parentPath));
    }

    handleMenuItemClick();
  };

  // Handle parent menu item click - expand submenu but don't collapse sidebar
  const handleParentMenuClick = (item: any) => {
    // On mobile (< 1024px), always use inline submenu expansion instead of secondary sidebar
    const isMobile = window.innerWidth < 1024;
    const key = menuPath(item);

    // When the rail is COLLAPSED (minimized) on desktop, clicking a module expands the rail
    // and opens that module's sub-modules inline — no flyout. toggleExpanded bails out while
    // still collapsed, so set the expanded state directly here.
    if (!isMobile && isCollapsed) {
      onToggleCollapse();
      setExpandedItems([key]);
      return;
    }

    // Expanded (or mobile): toggle the sub-modules inline as an accordion below the module —
    // for ALL parent types, including sidemenu/cardmenu.
    toggleExpanded(key);
  };

  // Handle single menu item click - auto-collapse sidebar and close secondary sidebar
  const handleSingleMenuItemClick = () => {
    // Close secondary sidebar when navigating to different main menu item
    if (secondarySidebar.isOpen) {
      setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
      setSecondarySidebarSearch('');
    }

    handleMenuItemClick();
  };

  // Handle tree view item click - don't collapse sidebar, just navigate
  const handleTreeViewItemClick = () => {
    // Close secondary sidebar when navigating
    if (secondarySidebar.isOpen) {
      setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
      setSecondarySidebarSearch('');
    }

    // On mobile, close the sidebar
    if (window.innerWidth < 1024) {
      onClose();
    }
    // Don't collapse sidebar on desktop for tree view
  };

  // Drill-down navigation handlers
  const handleDrillDown = (item: any) => {
    // console.log('handleDrillDown called with:', {
    // name: item.mnu_itm_nm || item.prnt_mnu_itm_nm,
    //   hasChildren: !!(item.children && item.children.length > 0),
    //   childrenCount: item.children?.length || 0,
    //   currentStackLength: drillDownStack.length
    // });
    if (item.children && item.children.length > 0) {
      setDrillDownStack(prev => {
        const newStack = [...prev, item];
        // console.log('New drill-down stack:', newStack.map(i => i.mnu_itm_nm || i.prnt_mnu_itm_nm));
        return newStack;
      });
    } else {
      // console.log('Item has no children, cannot drill down');
    }
  };

  /* The pin on a module row. It drills the rail INTO that module: the module's
     sub-modules become the whole list and every other module drops away, which
     is what people actually want the rail for once they are working inside one
     module all day. The breadcrumb that appears above the list carries Home
     (handleDrillToRoot) to bring all the modules back, and the drilled state is
     restored from localStorage on reload.

     Only modules with sub-modules get one — there is nothing to drill into
     otherwise. It rides on .rail-ctrl like the chevron, so it stays invisible
     until the row is hovered or keyboard-focused rather than adding a permanent
     glyph to all 16 rows. */
  const renderRowPin = (item: any) => {
    if (isCollapsed && !isOpen) return null;
    if (!item?.children || item.children.length === 0) return null;
    const isDrilledIn = currentDrillDownItem === item;
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleDrillDown(item); }}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); handleDrillDown(item); } }}
        className={`rail-ctrl rail-star w-[22px] h-[22px] flex items-center justify-center rounded-md cursor-pointer flex-shrink-0 ${isDrilledIn ? 'is-pinned' : ''}`}
        style={isDrilledIn ? { opacity: 1 } : undefined}
        title={`Show only ${item.prnt_mnu_itm_nm || item.mnu_itm_nm}`}
      >
        <i className={`sidebar-ctrl-icon ${isDrilledIn ? 'ri-star-fill' : 'ri-star-line'}`}></i>
      </span>
    );
  };

  const handleDrillUp = () => {
    setDrillDownStack(prev => prev.slice(0, -1));
  };

  const handleDrillToRoot = () => {
    setDrillDownStack([]);
  };

  // Get current items to display based on drill-down state
  const getDrillDownItems = () => {
    if (currentDrillDownItem && currentDrillDownItem.children) {
      return currentDrillDownItem.children;
    }
    return null;
  };

  // Override default NavLink active styles and add card menu styles
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* ==========================================================================
         THE RAIL

         Design brief, so the next person changing this knows what is load-bearing
         and what is taste.

         The rail before this one lit everything: a saturated violet ground, four
         blurred lights drifting across it on a 34s loop, a grain sheet over that,
         a bordered chip behind every icon, a glowing gradient pill on the current
         row, and two always-visible controls on the right of every module. Each
         piece was well made. Together they meant the surface was the loudest
         thing in the app, and the one question a sidebar exists to answer —
         WHICH ROW AM I ON — was competing with six decorations for attention.

         So the whole design is one trade: the surface gets quiet, and the state
         gets to be the only lit thing on it.

           · ground      near-black neutral, one static bloom behind the brand
           · idle row    muted slate label, bare icon, no chip, no fill
           · hovered     a 5% white wash and the label goes white
           · current     violet-tinted sheet, white label, violet icon, and a
                         3px spine flush against the rail's edge
           · controls    the pin appears on hover; the chevron is always there
                         but sits at 40% until you point at the row

         Nothing here moves unless the pointer is on it. That is deliberate: the
         rail sits in peripheral vision for the entire session, and motion in the
         periphery is a signal. It should not fire while somebody is reading a
         table.
         ========================================================================== */
      .sidebar-container a {
        background-color: transparent !important;
      }

      /* ---- CURRENT ROW --------------------------------------------------------
         Three cues, in order of how far away they work from: the spine (readable
         from the corner of the eye), the tinted sheet (readable at a glance), the
         white label and violet icon (readable when you look).

         A tint rather than a solid fill because the rail is dark and the tint
         still lands well clear of it; a solid violet key needed a drop shadow to
         separate from the violet ground it sat on, and that shadow was the single
         heaviest thing in the old rail. */
      .sidebar-container a.active,
      .sidebar-container .active,
      .sidebar-container .rail-row.is-active {
        background-color: var(--theme-sidemenu-active) !important;
        background-image: var(--theme-sidemenu-active-grad) !important;
        color: var(--theme-sidemenu-active-fg) !important;
        border-radius: var(--rail-radius) !important;
        font-weight: 600 !important;
        box-shadow: none !important;
        position: relative;
      }
      .sidebar-container a.active span,
      .sidebar-container .active span,
      .sidebar-container .rail-row.is-active span {
        color: var(--theme-sidemenu-active-fg) !important;
      }
      /* The icon on the current row goes violet-200 rather than white. White on
         white makes the icon and the label one blob; a lighter tint of the brand
         keeps them as two things and ties the icon to the spine. */
      .sidebar-container a.active .icon-circle i,
      .sidebar-container .active .icon-circle i,
      .sidebar-container .rail-row.is-active .icon-circle i {
        color: var(--theme-sidemenu-active-icon) !important;
      }
      /* THE SPINE.

         left is the negative of --rail-gutter, so the bar lands exactly on the
         rail's own left edge no matter what the gutter is set to — the rows are
         inset by the gutter, the spine reaches back out of them. It must not be
         nudged by hand: the previous -10px against a 12px row padding put it
         outside the nav's padding box, where overflow-x:hidden clipped it, which
         is why the old rail had a marker in the stylesheet and none on screen. */
      .sidebar-container .rail-row.is-active::before,
      .sidebar-container nav a.active::before {
        content: '';
        position: absolute;
        left: calc(-1 * var(--rail-gutter));
        top: 4px;
        bottom: 4px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background-color: var(--theme-sidemenu-marker);
        animation: rail-spine-in 180ms var(--rail-ease) both;
      }
      /* The collapsed rail is 64px of centred icons; there is no gutter to reach
         back through, so the tint carries the state on its own. */
      .sidebar-container.rail-collapsed .rail-row.is-active::before,
      .sidebar-container.rail-collapsed nav a.active::before {
        display: none;
      }
      @keyframes rail-spine-in {
        from { transform: scaleY(0.3); opacity: 0; }
        to   { transform: scaleY(1);   opacity: 1; }
      }

      /* ---- ANCESTOR ROW -------------------------------------------------------
         A module whose sub-module is open. It is NOT current — the sub-row below
         it is — so it must not wear the same clothes. It gets the white label and
         nothing else: enough to trace the path down to the open page, not enough
         to be mistaken for the destination. */
      .sidebar-container .rail-row.is-ancestor {
        background-color: transparent !important;
        background-image: none !important;
        box-shadow: none !important;
      }
      .sidebar-container .rail-row.is-ancestor .module-name,
      .sidebar-container .rail-row.is-ancestor span {
        color: var(--theme-sidemenu-hover-fg) !important;
        font-weight: 600 !important;
      }

      /* ---- LABELS -------------------------------------------------------------
         themeService walks the rail and writes sideMenuForeground inline on every
         span and every <i> a tick after React paints, so anything that needs to
         disagree with "the idle colour" has to say so with !important. That is
         not defensive coding, it is the only thing that works against an inline
         style written by a DOM sweep. */
      .sidebar-container .module-name {
        color: var(--theme-sidemenu-fg) !important;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: -0.005em;
        line-height: 1.25;
      }
      .sidebar-container nav i.sub-module-icon {
        color: var(--theme-sidemenu-fg) !important;
      }

      /* ---- SECTION EYEBROWS (wings, and headers inside a module) --------------
         Was "—— ADMINISTRATION ——", centred between two fading rules. Two rules
         and a centred label is three pieces of furniture to say "a group starts
         here", which whitespace says for free. What is left is a small muted
         label on the same left margin as the module names under it, with real air
         above it — so the grouping is read as rhythm rather than as drawn lines. */
      .sidebar-container .wing-label,
      .sidebar-container .rail-eyebrow {
        color: var(--theme-sidemenu-eyebrow) !important;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        text-transform: uppercase;
        letter-spacing: 0.13em;
      }
      .sidebar-container .drill-breadcrumb,
      .sidebar-container .drill-breadcrumb * {
        color: var(--theme-sidemenu-fg) !important;
      }
      .sidebar-active-item,
      .sidebar-active-card {
        background-color: var(--theme-sidemenu-active) !important;
        color: var(--theme-sidemenu-active-fg) !important;
        border-radius: var(--rail-radius) !important;
        box-shadow: none !important;
      }
      .sidebar-active-card {
        border-color: var(--theme-sidemenu-marker) !important;
      }
      .sidebar-active-card .text-xs {
        color: rgba(255, 255, 255, 0.75) !important;
      }

      /* ---- ICONS --------------------------------------------------------------
         .icon-circle is now a misnomer kept on purpose: the class is applied at a
         dozen call sites with inline background/border/box-shadow next to it, and
         renaming it would mean editing every one of them to no visible benefit.
         What it draws is a bare 20px slot. The inline styles it carries are
         answered here with !important — same reason as the labels above.

         Losing the chip is the change that does the most work in this redesign.
         Sixteen bordered circles in a 256px column drew sixteen boxes down the
         left edge, and boxes read as controls; the eye kept being drawn to the
         containers instead of to the names of the modules inside them. */
      .icon-circle {
        position: relative !important;
        overflow: visible !important;
        width: var(--rail-tile) !important;
        height: var(--rail-tile) !important;
        border-radius: 0 !important;
        background-color: transparent !important;
        background-image: none !important;
        border: 0 !important;
        box-shadow: none !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex-shrink: 0 !important;
      }
      .icon-circle i {
        font-size: var(--rail-icon);
        line-height: 1;
        transition: color var(--rail-dur) var(--rail-ease);
      }
      /* Sub-rows sit at a lower tier and their icons say so — one step smaller
         and never coloured, so a submenu never out-shouts the modules above it. */
      .rail-subrow .icon-circle {
        width: 16px !important;
        height: 16px !important;
      }
      .rail-subrow .icon-circle i {
        font-size: 15px;
      }
      .sidebar-icon-active {
        color: var(--theme-sidemenu-active-icon) !important;
      }
      .sidebar-icon-inactive {
        /* No !important: a module's own icn_clr_cd inline colour is allowed to
           win here. The per-module colours are data, not decoration. */
        color: var(--theme-sidemenu-fg);
      }

      /* ---- HOVER --------------------------------------------------------------
         A flat wash and a white label. Nothing lifts, nothing slides, nothing
         sweeps. The previous rail leaned the label 2px, floated the tile 1px,
         ran a specular band across the chip and brightened its border — four
         animations per row, on a surface people move a pointer across on the way
         to somewhere else.

         Driven by CSS :hover rather than by the imperative handlers, because an
         inline background written on mouseenter is wiped by the next React
         re-render and the row goes flat while the pointer is still on it. */
      .sidebar-container nav a:not(.active):hover,
      .sidebar-container nav button:not(.is-active):hover {
        background-color: var(--theme-sidemenu-hover) !important;
        background-image: none !important;
        color: var(--theme-sidemenu-hover-fg) !important;
        border-radius: var(--rail-radius) !important;
      }
      .sidebar-container nav a:not(.active):hover span,
      .sidebar-container nav button:not(.is-active):hover span {
        color: var(--theme-sidemenu-hover-fg) !important;
      }
      .sidebar-container nav a:not(.active):hover .icon-circle i,
      .sidebar-container nav button:not(.is-active):hover .icon-circle i {
        color: var(--theme-sidemenu-hover-fg) !important;
      }

      /* ---- ROW CONTROL (chevron) ---------------------------------------------
         One glyph per module row, not two. It rests at 40% and comes up to 75%
         when the row is pointed at, focused, or current — present enough to say
         "there is more under here", quiet enough that the module name is still
         the thing you read.

         It fades by OPACITY, never by display, so the hit target never moves
         under the cursor and Tab still reaches it. */
      .sidebar-container .rail-ctrl {
        color: var(--theme-sidemenu-eyebrow) !important;
        opacity: 0.4;
        transition: opacity var(--rail-dur) var(--rail-ease),
                    background-color var(--rail-dur) var(--rail-ease);
      }
      .sidebar-container .rail-row:hover .rail-ctrl,
      .sidebar-container .rail-row.is-active .rail-ctrl,
      .sidebar-container .rail-row:focus-within .rail-ctrl {
        opacity: 0.75;
      }
      .sidebar-container .rail-ctrl:hover {
        opacity: 1 !important;
        background-color: rgba(255, 255, 255, 0.10);
      }
      .sidebar-container .rail-row.is-active .rail-ctrl,
      .sidebar-container .rail-row.is-active .rail-ctrl i {
        color: var(--theme-sidemenu-active-fg) !important;
      }
      .sidebar-container .sidebar-ctrl-icon {
        color: inherit !important;
        font-size: 15px;
      }

      /* ---- SUBMENU ------------------------------------------------------------
         An open module's options hang off a 1px guide line rather than sitting in
         a block of indented rows. The line is what makes a nested list read as
         nested from across the room — indentation alone is ambiguous once two
         modules are open at once. */
      .sidebar-container .rail-sub {
        position: relative;
        margin-left: var(--rail-indent);
        padding-left: 10px;
      }
      .sidebar-container .rail-sub::before {
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        bottom: 6px;
        width: 1px;
        background-color: var(--theme-sidemenu-guide);
      }
      .sidebar-container .rail-subrow {
        min-height: var(--rail-subrow-h) !important;
        font-size: 12.5px;
      }
      .sidebar-container .rail-subrow .module-name {
        font-size: 12.5px;
      }
      /* The open leaf puts a dot ON the guide line — the line becomes a scale and
         the dot is the reading on it. */
      .sidebar-container .rail-sub a.active::before {
        content: '';
        position: absolute;
        /* -(padding-left 10 + half the dot 2.5 - half the line 0.5) — i.e. the
           dot's centre lands on the guide line's centre. */
        left: -12px;
        top: 50%;
        /* bottom:auto undoes the spine rule above, which also matches
           "nav a.active::before" and would otherwise leave this over-constrained
           with a top, a bottom AND a height all set at once.
           (No backticks in this comment on purpose — the whole stylesheet is a
           JS template literal, and one would end it here.) */
        bottom: auto;
        transform: translateY(-50%);
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: var(--theme-sidemenu-marker);
        animation: none;
      }

      /* ---- SEARCH -------------------------------------------------------------
         A well cut into the surface: a 5% fill, a hairline, and no shadow. On
         focus the border takes the brand and a single soft ring appears — one
         change of state, not the previous ring + glow + shadow + scale. */
      .sidebar-container .sidebar-search-input {
        background-color: var(--theme-sidemenu-glass) !important;
        border: 1px solid var(--theme-sidemenu-glass-border) !important;
        box-shadow: none !important;
        color: #ffffff !important;
        font-size: 13px !important;
        height: 34px;
        border-radius: 9px !important;
        transition: background-color var(--rail-dur) var(--rail-ease),
                    border-color var(--rail-dur) var(--rail-ease),
                    box-shadow var(--rail-dur) var(--rail-ease);
      }
      .sidebar-container .sidebar-search-input::placeholder {
        color: var(--theme-sidemenu-eyebrow) !important;
        opacity: 1;
      }
      .sidebar-container .sidebar-search-input:hover {
        background-color: rgba(255, 255, 255, 0.07) !important;
      }
      .sidebar-container .sidebar-search-input:focus {
        background-color: rgba(255, 255, 255, 0.07) !important;
        border-color: var(--theme-sidemenu-marker) !important;
        box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.16) !important;
        outline: none !important;
      }
      .sidebar-container .sidebar-search-icon i {
        color: var(--theme-sidemenu-eyebrow) !important;
        font-size: 15px;
      }
      .sidebar-container kbd {
        background-color: rgba(255, 255, 255, 0.06) !important;
        border-color: var(--theme-sidemenu-glass-border) !important;
        color: var(--theme-sidemenu-eyebrow) !important;
      }

      /* ---- THE GROUND ---------------------------------------------------------
         One bloom, static, behind the brand block.

         z-index:-1 is load-bearing and has nothing to do with the design: the
         container is position:fixed with a z-index, so it opens a stacking
         context, and inside it an absolutely positioned pseudo-element at
         z-index auto paints above static block descendants — i.e. on top of the
         entire menu. -1 puts it behind the rows and still above the container's
         own background, which is the one layer this needs.

         The negative inset keeps the blur's own soft edge outside the rail; blur
         applied at the edge of its box draws a visible border, which is exactly
         what a bloom must not have. */
      .sidebar-container::before {
        content: '';
        position: absolute;
        inset: -20% -30% 40% -30%;
        z-index: -1;
        pointer-events: none;
        background-image: var(--theme-sidemenu-mesh);
        filter: blur(var(--theme-sidemenu-flow-blur));
      }
      /* Dark mode: a plain navy rail — no city photo under the wash, no bloom.
         !important answers the inline backgroundImage on the aside. */
      html.dark .sidebar-container {
        background-image: none !important;
        background-color: #06142b !important;
      }
      html.dark .sidebar-container::before {
        display: none;
      }

      /* ---- ROW GEOMETRY -------------------------------------------------------
         One height, one radius, one gutter, one curve. This is what makes the
         parts look like they were drawn by the same hand. */
      .sidebar-container nav a,
      .sidebar-container nav button {
        min-height: var(--rail-row-h);
        border-radius: var(--rail-radius);
        transition: background-color var(--rail-dur) var(--rail-ease),
                    color var(--rail-dur) var(--rail-ease);
      }

      .sidebar-container a:focus-visible,
      .sidebar-container button:focus-visible,
      .sidebar-container input:focus-visible {
        outline: 2px solid var(--theme-sidemenu-marker);
        outline-offset: 2px;
        border-radius: var(--rail-radius);
      }

      /* The rail's own scrollbar: the surface's colour at low alpha, and only
         while the pointer is in the rail. overflow-x:hidden is not cosmetic —
         overflow-y:auto silently makes the X axis auto too, and a couple of
         stray pixels of row width were enough to flash a horizontal scrollbar in
         and out, which resized the scroll area, which moved the rows under the
         cursor. Nothing in the rail ever scrolls sideways. */
      .sidebar-container nav {
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
        transition: scrollbar-color var(--rail-dur) var(--rail-ease);
      }
      .sidebar-container:hover nav {
        scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
      }
      .sidebar-container nav::-webkit-scrollbar {
        width: 6px;
      }
      .sidebar-container nav::-webkit-scrollbar-track {
        background: transparent;
      }
      .sidebar-container nav::-webkit-scrollbar-thumb {
        background-color: transparent;
        border-radius: 3px;
        transition: background-color var(--rail-dur) var(--rail-ease);
      }
      .sidebar-container:hover nav::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.18);
      }
      .sidebar-container nav::-webkit-scrollbar-thumb:hover {
        background-color: rgba(255, 255, 255, 0.32);
      }

      /* Someone who has asked the OS for less motion gets every colour and none
         of the travel. There is very little travel left to remove — which is
         itself the point. */
      @media (prefers-reduced-motion: reduce) {
        .sidebar-container nav a,
        .sidebar-container nav button,
        .sidebar-container .icon-circle i,
        .sidebar-container .rail-ctrl {
          transition-duration: 1ms !important;
        }
        .sidebar-container .rail-row.is-active::before,
        .sidebar-container nav a.active::before {
          animation: none;
        }
      }

      /* ==========================================================================
         DTCP SKIN — a white card on the warm page, in both themes

           · ground      white card (#241A10 in dark), radius 18, soft brown shadow
           · labels      ink at 15px/500, line icons at 20px
           · eyebrows    11px bold caps, letter-spacing .12em, muted
           · current     solid gold #F2BD4A pill with bold ink type
           · hover       the soft surface (#FAF6EF)
           · controls    star (drill-in pin, gold when pinned) and chevron

         The attribute is still [data-skin="cream"] so nothing outside this file
         has to change. The palette re-declares the --theme-sidemenu-* tokens on
         the aside itself, so every var()-driven rule above follows. Those tokens
         are set inline on <html> by themeService; a declaration on the aside is
         nearer to the rows and wins for them. "html" leads every selector so it
         out-ranks the html.dark navy rule above.
         ========================================================================== */
      html .sidebar-container[data-skin="cream"] {
        --dtcp-card: #ffffff;
        --dtcp-soft: #FAF6EF;
        --dtcp-border: #ECE2D3;
        --dtcp-ink: #2A1D0E;
        --dtcp-muted: #7A6A56;
        --dtcp-gold: var(--brand-accent);
        --dtcp-deep-gold: var(--brand-deep);
        --dtcp-cream: var(--brand-cream);

        --theme-sidemenu-bg: var(--dtcp-card);
        --theme-sidemenu-grad-from: var(--dtcp-card);
        --theme-sidemenu-grad-to: var(--dtcp-card);
        --theme-sidemenu-mesh: none;
        --theme-sidemenu-fg: var(--dtcp-ink);
        --theme-sidemenu-hover: var(--dtcp-soft);
        --theme-sidemenu-hover-fg: var(--dtcp-ink);
        --theme-sidemenu-active: var(--brand-accent);
        --theme-sidemenu-active-grad: none;
        --theme-sidemenu-active-fg: #2A1D0E;
        --theme-sidemenu-active-icon: #2A1D0E;
        --theme-sidemenu-marker: var(--dtcp-deep-gold);
        --theme-sidemenu-eyebrow: var(--dtcp-muted);
        --theme-sidemenu-glass: var(--dtcp-soft);
        --theme-sidemenu-glass-border: var(--dtcp-border);
        --theme-sidemenu-divider: var(--dtcp-border);
        --theme-sidemenu-guide: var(--dtcp-border);
        --rail-row-h: 44px;
        --rail-subrow-h: 36px;
        --rail-tile: 22px;
        --rail-icon: 20px;
        --rail-indent: 22px;
        --rail-radius: 12px;
        --rail-gutter: 12px;

        font-family: 'Outfit', 'Inter', system-ui, sans-serif;
        /* !important: themeService writes sideMenuBackground inline on every
           [data-theme="sidebar"] element. */
        background-color: var(--dtcp-card) !important;
        background-image: none !important;
        border: 1px solid var(--dtcp-border) !important;
        box-shadow: 0 2px 12px rgba(60, 35, 5, 0.06) !important;
        color: var(--dtcp-ink) !important;
      }
      html.dark .sidebar-container[data-skin="cream"] {
        --dtcp-card: #241A10;
        --dtcp-soft: #2E2216;
        --dtcp-border: #3A2C1C;
        --dtcp-ink: #F3EAD9;
        --dtcp-muted: #B3A48F;
        --dtcp-cream: #3A2C1C;
      }
      html .sidebar-container[data-skin="cream"]::before {
        display: none;
      }
      /* The mobile drawer runs edge to edge; only the desktop card is rounded. */
      @media (min-width: 1024px) {
        html .sidebar-container[data-skin="cream"] {
          border-radius: 18px;
        }
      }
      /* themeService also writes sideMenuForeground inline on every span, div
         and icon in the rail. Inline beats any stylesheet rule that is not
         !important, so this answers it — at the lowest specificity :where()
         allows, so every specific rule above and below still wins over it. */
      :where([data-skin="cream"]) :where(span, p, div, a, button, h1, h2, h3, h4, h5, h6, i) {
        color: var(--theme-sidemenu-fg) !important;
      }
      /* ...except an icon on a control that has painted its own hover fill. */
      :where([data-skin="cream"]) button:hover > i {
        color: inherit !important;
      }

      /* ---- Top row: MENU label + collapse button ---- */
      html .sidebar-container[data-skin="cream"] .rail-menu-label {
        color: var(--dtcp-muted) !important;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.12em;
      }
      html .sidebar-container[data-skin="cream"] .rail-collapse-btn {
        background-color: var(--dtcp-deep-gold) !important;
        color: #ffffff !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-collapse-btn i {
        color: #ffffff !important;
      }

      /* ---- Menu search ---- */
      html .sidebar-container[data-skin="cream"] .rail-search-input {
        background-color: var(--dtcp-soft);
        border: 1px solid var(--dtcp-border);
        border-radius: 10px;
        color: var(--dtcp-ink);
        font-size: 14px;
        outline: none;
        transition: border-color 150ms ease, box-shadow 150ms ease, background-color 150ms ease;
      }
      html .sidebar-container[data-skin="cream"] .rail-search-input::placeholder {
        color: var(--dtcp-muted);
        opacity: 1;
      }
      html .sidebar-container[data-skin="cream"] .rail-search-input:focus {
        background-color: var(--dtcp-card);
        border-color: var(--brand-deep);
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-accent) 35%, transparent);
      }
      html .sidebar-container[data-skin="cream"] .rail-search-icon,
      html .sidebar-container[data-skin="cream"] .rail-search-clear i {
        color: var(--dtcp-muted) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-search-clear:hover {
        background-color: var(--dtcp-border);
      }
      html .sidebar-container[data-skin="cream"] .rail-search-kbd {
        background-color: var(--dtcp-card) !important;
        border: 1px solid var(--dtcp-border) !important;
        color: var(--dtcp-muted) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-search-collapsed {
        background-color: var(--dtcp-soft);
        border: 1px solid var(--dtcp-border);
      }
      html .sidebar-container[data-skin="cream"] .rail-search-collapsed:hover {
        background-color: color-mix(in srgb, var(--brand-accent) 25%, transparent);
      }

      /* ---- Labels ---- */
      html .sidebar-container[data-skin="cream"] .module-name {
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.25;
      }
      html .sidebar-container[data-skin="cream"] .rail-subrow .module-name {
        font-size: 14px;
        font-weight: 500;
      }
      html .sidebar-container[data-skin="cream"] .wing-label,
      html .sidebar-container[data-skin="cream"] .rail-eyebrow {
        color: var(--dtcp-muted) !important;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.12em;
      }
      html .sidebar-container[data-skin="cream"] .rail-new-badge {
        background-color: #2F8F5B !important;
        color: #ffffff !important;
        font-size: 9.5px;
        font-weight: 700;
        letter-spacing: 0.06em;
        line-height: 1;
        padding: 3px 6px;
        border-radius: 999px;
      }

      /* ---- Icons: 20px line glyphs ---- */
      html .sidebar-container[data-skin="cream"] .icon-circle .rail-top-icon {
        font-size: 20px;
      }
      html .sidebar-container[data-skin="cream"] .icon-circle i.sidebar-icon-inactive {
        color: var(--dtcp-ink) !important;
      }
      html .sidebar-container[data-skin="cream"] nav i.sub-module-icon {
        color: var(--dtcp-muted) !important;
      }
      html .sidebar-container[data-skin="cream"] nav a:not(.active):hover .icon-circle i,
      html .sidebar-container[data-skin="cream"] nav button:not(.is-active):hover .icon-circle i {
        color: var(--dtcp-ink) !important;
      }

      /* ---- Current module: accent pill, ink type, a soft ring ----
         The module you are in — its own page (is-active) or one of its
         options (is-ancestor) — wears the palette accent. */
      html .sidebar-container[data-skin="cream"] .rail-row.is-active,
      html .sidebar-container[data-skin="cream"] .rail-row.is-ancestor {
        background-color: var(--brand-accent) !important;
        background-image: none !important;
        box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-accent) 28%, transparent),
                    0 4px 10px -6px color-mix(in srgb, var(--brand-deep) 60%, transparent) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-row.is-active :is(.module-name, i, span),
      html .sidebar-container[data-skin="cream"] .rail-row.is-ancestor :is(.module-name, i, span) {
        color: #2A1D0E !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-row:is(.is-active, .is-ancestor) .module-name {
        font-weight: 700 !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-row.is-active .rail-new-badge,
      html .sidebar-container[data-skin="cream"] .rail-row.is-ancestor .rail-new-badge {
        color: #ffffff !important;
      }
      /* The pill carries the state on its own; the spine would be a second,
         competing marker on its left edge. */
      html .sidebar-container[data-skin="cream"] .rail-row.is-active::before {
        display: none;
      }

      /* ---- Current option: solid deep pill, white type ---- */
      html .sidebar-container[data-skin="cream"] .rail-sub a.active {
        background-color: var(--brand-deep) !important;
        background-image: none !important;
        box-shadow: 0 4px 10px -6px color-mix(in srgb, var(--brand-deep) 80%, transparent) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-sub a.active :is(.module-name, span) {
        color: #ffffff !important;
        font-weight: 700 !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-sub a.active::before {
        display: none;
      }

      /* ---- Options: no guide line, a small coloured tile per option ---- */
      html .sidebar-container[data-skin="cream"] .rail-sub {
        margin-left: 8px;
        padding-left: 0;
      }
      html .sidebar-container[data-skin="cream"] .rail-sub::before {
        display: none;
      }
      html .sidebar-container[data-skin="cream"] .rail-subrow {
        border-radius: 10px !important;
      }
      .sidebar-container .sub-tile {
        width: 22px;
        height: 22px;
        border-radius: 6px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: var(--tile, var(--brand-deep));
      }
      html .sidebar-container[data-skin="cream"] .sub-tile i.sub-module-icon {
        color: #ffffff !important;
        font-size: 13px;
        line-height: 1;
      }
      html .sidebar-container[data-skin="cream"] .rail-sub a.active .sub-tile {
        background-color: rgba(255, 255, 255, 0.22);
      }

      /* ---- Controls: chevron quiet; the drill-in star only on hover ---- */
      html .sidebar-container[data-skin="cream"] .rail-ctrl {
        color: var(--dtcp-muted) !important;
        opacity: 0.8;
      }
      html .sidebar-container[data-skin="cream"] .rail-ctrl:hover {
        background-color: color-mix(in srgb, var(--brand-accent) 25%, transparent);
      }
      html .sidebar-container[data-skin="cream"] .rail-ctrl i {
        color: var(--dtcp-muted) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-star {
        opacity: 0;
      }
      html .sidebar-container[data-skin="cream"] .rail-row:hover .rail-star,
      html .sidebar-container[data-skin="cream"] .rail-row:focus-within .rail-star,
      html .sidebar-container[data-skin="cream"] .rail-star.is-pinned {
        opacity: 1;
      }
      html .sidebar-container[data-skin="cream"] .rail-star .sidebar-ctrl-icon {
        font-size: 13px;
      }
      html .sidebar-container[data-skin="cream"] .rail-star.is-pinned i {
        color: var(--brand-deep) !important;
      }
      html .sidebar-container[data-skin="cream"] .rail-row:is(.is-active, .is-ancestor) .rail-ctrl i {
        color: #2A1D0E !important;
      }

      /* ---- Scrollbar ---- */
      html .sidebar-container[data-skin="cream"]:hover nav {
        scrollbar-color: var(--brand-2) transparent;
      }
      html .sidebar-container[data-skin="cream"]:hover nav::-webkit-scrollbar-thumb {
        background-color: var(--brand-2);
      }
      html .sidebar-container[data-skin="cream"] nav::-webkit-scrollbar-thumb:hover {
        background-color: var(--brand-3);
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Update current active path when location changes
  useEffect(() => {
    setCurrentActivePath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      if (secondarySidebarTimeoutRef.current) {
        clearTimeout(secondarySidebarTimeoutRef.current);
      }
    };
  }, []);

  const renderSecondarySidebar = () => {
    if (!secondarySidebar.isOpen || !secondarySidebar.item || !secondarySidebar.item.children) return null;

    const item = secondarySidebar.item;

    // Open the flyout where the module list starts and run it full height to the bottom.
    const flyoutTop = Math.max(0, secondaryAnchorTop ?? 80);

    // Filter children based on search
    const filteredChildren = item?.children?.filter((child: any) =>
      child.mnu_itm_nm.toLowerCase().includes(secondarySidebarSearch.toLowerCase()) ||
      (child.t_mnu_itm_nm && child.t_mnu_itm_nm.toLowerCase().includes(secondarySidebarSearch.toLowerCase()))
    );

    return (
      <div
        className="sub-sidenav fixed left-0 border transition-all duration-200 z-[6000] animate-in slide-in-from-left-2 w-64 flex flex-col overflow-hidden"
        style={{
          // Flush against the rail, wherever the shell has placed it.
          left: asideRef.current
            ? `${Math.round(asideRef.current.getBoundingClientRect().right) + 8}px`
            : (isCollapsed ? '4.5rem' : '16.25rem'),
          // Starts where the module list begins and runs the full remaining height. No radius.
          top: flyoutTop,
          height: `calc(100vh - ${flyoutTop}px)`,
          // Match the main sidenav background (ice blue). Use the GRADIENT var, not
          // --theme-sidemenu-bg, because ThemeContext overrides the latter to white at
          // runtime; the gradient var keeps the real sidebar colour in both themes.
          backgroundColor: 'var(--theme-sidemenu-grad-from)',
          // The rail's own divider, NOT --theme-border. --theme-border is the
          // content area's token (#e5e7eb, a light grey) and drew a pale outline
          // around a near-black panel — the flyout looked like it had been cut
          // out and pasted on. Same swap everywhere else in this panel.
          borderColor: 'var(--theme-sidemenu-divider)',
          color: 'var(--theme-sidemenu-fg)',
          // This one IS a floating layer, so it keeps a shadow — but a neutral
          // one, and only to its right where it leaves the rail. The rail itself
          // no longer casts anything; the difference is what tells you the flyout
          // is temporary and the rail is not.
          boxShadow: '16px 0 40px -12px rgba(0, 0, 0, 0.55)'
        }}
        onMouseEnter={handleSecondarySidebarEnter}
        onMouseLeave={handleSecondarySidebarLeave}
      >
        {/* Header Section */}
        <div
          className="h-16 flex items-center px-4 border-b flex-shrink-0"
          style={{
            borderColor: 'var(--theme-sidemenu-divider)',
            // Ice blue to match the flyout body (see note above re: gradient var).
            backgroundColor: 'var(--theme-sidemenu-grad-from)'
          }}
        >
          <div className="flex items-center flex-1">
            <div
              className="w-8 h-8 rounded-full flex items-center justify-center mr-3"
              style={{ backgroundColor: 'var(--theme-primary)' }}
            >
              <i className={`${item.mnu_itm_icn_tx || item.prnt_mnu_icn_tx || 'ri-circle-line'} text-base bg-transparent text-white`}></i>
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-sm" style={{ color: '#ffffff' }}>
                {item.prnt_mnu_itm_nm || item.mnu_itm_nm}
              </h3>
            </div>
          </div>
          {/* Close Button */}
          <button
            onClick={() => {
              setSecondarySidebar({ item: null, isOpen: false, openedByClick: false });
              setSecondarySidebarSearch('');
            }}
            className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-200 hover:bg-opacity-20"
            style={{
              backgroundColor: 'transparent',
              color: '#ffffff'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--theme-sidemenu-hover)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
            title="Close menu"
          >
            <i className="ri-close-line text-lg bg-transparent"></i>
          </button>
        </div>

        {/* Search Section */}
        <div className="px-3 py-3 border-b flex-shrink-0" style={{ borderColor: 'var(--theme-sidemenu-divider)' }}>
          <div className="relative">
            <input
              type="text"
              placeholder="Search menu items..."
              value={secondarySidebarSearch}
              onChange={(e) => setSecondarySidebarSearch(e.target.value)}
              className="w-full px-3 py-2 pl-9 pr-8 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-blue-400 focus:border-blue-500"
              /*
               * The flyout paints its surface from --theme-sidemenu-grad-from, so it
               * is the same violet as the rail and this field needs the rail's glass,
               * not the white-field treatment it carried. The old comment said "search
               * field background is white (light mode), so use black text" — the
               * background it named was --theme-sidemenu-bg, which is no longer white,
               * and black text on it would have been invisible.
               */
              style={{
                backgroundColor: 'var(--theme-sidemenu-glass)',
                borderColor: 'var(--theme-sidemenu-glass-border)',
                boxShadow: 'var(--theme-sidemenu-glass-inner)',
                color: '#ffffff'
              }}
              autoComplete="off"
              spellCheck="false"
            />
            <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-sm"
              style={{ color: 'var(--theme-text-muted)' }}></i>
            {secondarySidebarSearch && (
              <button
                onClick={() => setSecondarySidebarSearch('')}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                title="Clear search"
              >
                <i className="ri-close-line text-sm"></i>
              </button>
            )}
          </div>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 min-h-0 py-1 overflow-y-auto">
          {/* Main Item Heading */}
          <div
            className="px-4 py-3 border-b relative overflow-hidden"
            style={{
              borderColor: 'var(--theme-sidemenu-divider)',
              background: `linear-gradient(135deg,
                color-mix(in srgb, var(--theme-primary) 8%, var(--theme-sidemenu-bg)) 0%,
                color-mix(in srgb, var(--theme-primary) 4%, var(--theme-sidemenu-bg)) 100%)`,
              backgroundImage: `
                linear-gradient(135deg,
                  color-mix(in srgb, var(--theme-primary) 8%, var(--theme-sidemenu-bg)) 0%,
                  color-mix(in srgb, var(--theme-primary) 4%, var(--theme-sidemenu-bg)) 100%),
                repeating-linear-gradient(
                  45deg,
                  transparent,
                  transparent 10px,
                  color-mix(in srgb, var(--theme-primary) 2%, transparent) 10px,
                  color-mix(in srgb, var(--theme-primary) 2%, transparent) 20px
                )
              `
            }}
          >
            {/* Decorative corner accent */}
            <div
              className="absolute top-0 right-0 w-16 h-16 opacity-10"
              style={{
                background: `radial-gradient(circle at top right, var(--theme-primary), transparent 70%)`
              }}
            ></div>

            <h4
              className="text-xs font-semibold uppercase tracking-wider relative z-10 flex items-center"
              style={{ color: 'var(--theme-sidemenu-fg)' }}
            >
              <div
                className="w-1 h-4 rounded-full mr-2"
                style={{ backgroundColor: 'var(--theme-primary)' }}
              ></div>
              {item.prnt_mnu_itm_nm || item.mnu_itm_nm}
            </h4>
          </div>

          {item.mnu_vw_in === 'cardmenu' ? (
            // Card layout for cardmenu type
            <div className="grid grid-cols-2 gap-3 p-3">
              {filteredChildren.length > 0 ? (
                filteredChildren.map((child: any) => (
                  <NavLink
                    key={child.mnu_itm_url_tx}
                    to={child.mnu_itm_url_tx}
                    end
                    onClick={() => {
                      // Don't auto-close, let user close explicitly
                      handleMenuItemClick();
                    }}
                    className="block p-3 rounded-lg border-2 transition-all duration-200 cursor-pointer group"
                    style={{
                      backgroundColor: currentActivePath === child.mnu_itm_url_tx ? 'var(--theme-primary)' : 'var(--theme-bg-secondary)',
                      borderColor: currentActivePath === child.mnu_itm_url_tx ? 'var(--theme-primary)' : 'var(--theme-sidemenu-divider)',
                      color: currentActivePath === child.mnu_itm_url_tx ? '#ffffff' : 'var(--theme-sidemenu-fg)'
                    }}
                    onMouseEnter={(e) => {
                      if (currentActivePath !== child.mnu_itm_url_tx) applyMenuHover(e.currentTarget, 'card');
                    }}
                    onMouseLeave={(e) => {
                      if (currentActivePath !== child.mnu_itm_url_tx) clearMenuHover(e.currentTarget, 'card');
                    }}
                  >
                    <div className="text-center">
                      <div
                        className="icon-circle w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-3 transition-all duration-200"
                        style={{
                          backgroundColor: currentActivePath === child.mnu_itm_url_tx
                            ? '#7c3aed'
                            : 'transparent',
                          border: currentActivePath === child.mnu_itm_url_tx
                            ? `2px solid #7c3aed`
                            : '2px solid var(--theme-border)'
                        }}
                      >
                        <i className={`${child.mnu_itm_icn_tx || 'ri-circle-line'} text-xl transition-colors duration-200 bg-transparent ${currentActivePath === child.mnu_itm_url_tx
                            ? 'sidebar-icon-active'
                            : 'sidebar-icon-inactive'
                          }`}
                          style={child.mnu_itm_icn_clr_cd && currentActivePath !== child.mnu_itm_url_tx ? { color: child.mnu_itm_icn_clr_cd } : undefined}>
                        </i>
                      </div>
                      <div className="text-sm font-medium leading-tight">{child.mnu_itm_nm}</div>
                    </div>
                  </NavLink>
                ))
              ) : (
                <div className="col-span-2 px-3 py-8 text-center" style={{ color: 'var(--theme-text-muted)' }}>
                  <i className="ri-search-line text-2xl mb-2"></i>
                  <p className="text-sm">No items found</p>
                  <p className="text-xs mt-1">Try a different search term</p>
                </div>
              )}
            </div>
          ) : (
            // List layout for other menu types (sidemenu, submenu)
            <div>
              {filteredChildren.length > 0 ? (
                filteredChildren.map((child: any) => {
                  // Check if this is a section header (hdr_in = true/1)
                  const isHeader = child.hdr_in === true || child.hdr_in === 1 || child.hdr_in === 't';

                  if (isHeader) {
                    // Render as styled section header (non-clickable)
                    return (
                      <div
                        key={child.mnu_itm_nm}
                        className="px-4 py-2.5 relative overflow-hidden select-none"
                        style={{
                          background: `linear-gradient(135deg,
                            color-mix(in srgb, var(--theme-primary) 12%, var(--theme-sidemenu-bg)) 0%,
                            color-mix(in srgb, var(--theme-primary) 6%, var(--theme-sidemenu-bg)) 100%)`,
                          borderBottom: '1px solid var(--theme-border)',
                          cursor: 'default',
                          pointerEvents: 'none'
                        }}
                      >
                        <div className="flex items-center">
                          <div
                            className="w-1.5 h-5 rounded-full mr-3"
                            style={{ backgroundColor: 'var(--theme-primary)' }}
                          ></div>
                          <span
                            className="text-xs font-bold uppercase tracking-wider"
                            style={{ color: 'var(--theme-primary)' }}
                          >
                            {child.mnu_itm_nm}
                          </span>
                        </div>
                      </div>
                    );
                  }

                  // Render as regular NavLink.
                  // `currentActivePath` mirrors location.pathname, so the exact
                  // comparison it used has the same blind spot as the rows above:
                  // it goes dark as soon as the screen redirects into a sub-path.
                  const childIsActive = isRowActive(child.mnu_itm_url_tx) ||
                    currentActivePath === child.mnu_itm_url_tx;
                  return (
                    <NavLink
                      key={child.mnu_itm_url_tx}
                      to={child.mnu_itm_url_tx}
                      end={!matchesBySubTree(child.mnu_itm_url_tx)}
                      onClick={() => {
                        // Don't auto-close, let user close explicitly
                        handleMenuItemClick();
                      }}
                      className="flex items-center px-4 py-2.5 text-base font-medium transition-all duration-200 cursor-pointer group"
                      style={{
                        // Match the main sidebar's active look: pale indigo pill + indigo
                        // text + left accent bar (not the old solid dark-blue fill).
                        backgroundColor: childIsActive ? 'var(--theme-primary)' : 'transparent',
                        // White text on the dark flyout surface (active and inactive).
                        color: '#ffffff',
                        boxShadow: undefined,
                        fontWeight: childIsActive ? 600 : undefined,
                        // Rounded on the left side only, so the pill curves away from the
                        // accent bar and stays flush with the panel's right edge.
                        borderTopLeftRadius: childIsActive ? '0' : undefined,
                        borderBottomLeftRadius: childIsActive ? '0' : undefined
                      }}
                      onMouseEnter={(e) => {
                        if (!childIsActive) applyMenuHover(e.currentTarget);
                      }}
                      onMouseLeave={(e) => {
                        if (!childIsActive) clearMenuHover(e.currentTarget, 'row', '#ffffff');
                      }}
                    >
                      <div
                        className="icon-circle w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0 transition-all duration-200"
                        style={{
                          backgroundColor: childIsActive
                            ? '#7c3aed'
                            : (child.mnu_itm_icn_clr_cd ? getLighterColor(child.mnu_itm_icn_clr_cd) : 'var(--theme-bg-secondary)'),
                          border: childIsActive
                            ? `2px solid #7c3aed`
                            : (child.mnu_itm_icn_clr_cd ? `2px solid ${getLighterColor(child.mnu_itm_icn_clr_cd, 0.3)}` : '2px solid var(--theme-border)')
                        }}
                      >
                        <i className={`${child.mnu_itm_icn_tx || 'ri-circle-line'} text-lg transition-colors duration-200 bg-transparent ${childIsActive
                            ? 'sidebar-icon-active'
                            : 'sidebar-icon-inactive'
                          }`}
                          style={child.mnu_itm_icn_clr_cd && !childIsActive ? { color: child.mnu_itm_icn_clr_cd } : undefined}>
                        </i>
                      </div>
                      <div className="flex-1">
                        <span className="block">{child.mnu_itm_nm}</span>
                      </div>
                    </NavLink>
                  );
                })
              ) : (
                <div className="px-3 py-8 text-center" style={{ color: 'var(--theme-text-muted)' }}>
                  <i className="ri-search-line text-2xl mb-2"></i>
                  <p className="text-sm">No items found</p>
                  <p className="text-xs mt-1">Try a different search term</p>
                </div>
              )
              }
            </div>
          )}
        </nav>
      </div>
    );
  };

  /**
   * Keep each module's operational submodules in their configured order, but place
   * the two cross-cutting areas at the end. This is shared by the expanded accordion,
   * collapsed flyout, tree view and drilled-in view so the sidebar is consistent in
   * every display mode.
   */
  const orderModuleChildren = (children: any[]): any[] => {
    if (!Array.isArray(children) || children.length < 2) return children || [];
    const rank = (child: any): number => {
      const label = String(child?.mnu_itm_nm || child?.prnt_mnu_itm_nm || '').trim().toLowerCase();
      if (label === 'setup') return 1;
      if (label === 'reports' || label === 'report') return 2;
      return 0;
    };
    return children
      .map((child, index) => ({ child, index, rank: rank(child) }))
      .sort((a, b) => a.rank - b.rank || a.index - b.index)
      .map(({ child }) => child);
  };

  const renderPopupMenu = (item: any) => {
    if (!isCollapsed || hoveredItem !== item.prnt_mnu_itm_url_tx) return null;

    return (
      <div
        className="sub-sidenav fixed z-[5000] animate-in fade-in-0 slide-in-from-left-2 duration-200"
        style={{
          left: hoveredMenuPosition.x,
          top: hoveredMenuPosition.y,
          maxHeight: 'calc(100vh - 32px)'
        }}
        onMouseEnter={handlePopupEnter}
        onMouseLeave={handlePopupLeave}
      >
        <div
          className="rounded-lg shadow-xl border overflow-hidden min-w-[220px] max-w-[280px]"
          style={{
            backgroundColor: 'var(--theme-sidemenu-bg)',
            borderColor: 'var(--theme-sidemenu-divider)',
            color: 'var(--theme-sidemenu-fg)'
          }}
        >
          {item.children ? (
            <>
              {/* Header for items with submenus */}
              <div
                className="px-4 py-3 border-b"
                style={{
                  borderColor: 'var(--theme-sidemenu-divider)',
                  background: `color-mix(in srgb, var(--theme-sidemenu-bg) 95%, var(--theme-primary) 5%)`
                }}
              >
                <div className="flex items-center">
                  <div
                    className="w-7 h-7 rounded-full flex items-center justify-center mr-3"
                    style={{ backgroundColor: 'var(--theme-primary)' }}
                  >
                    <i className={`${item.mnu_itm_icn_tx || 'ri-circle-line'} text-base bg-transparent`} style={{ color: '#ffffff' }}></i>
                  </div>
                  <span className="font-medium text-sm" style={{ color: 'var(--theme-sidemenu-fg)' }}>{item.mnu_itm_nm}</span>
                </div>
              </div>

              {/* Submenu items */}
              <div className="py-2">
                <div className="space-y-1 px-2">
                  {orderModuleChildren(item.children).map((child: any) => (
                    <NavLink
                      key={child.mnu_itm_url_tx}
                      to={child.mnu_itm_url_tx}
                      end={!matchesBySubTree(child.mnu_itm_url_tx)}
                      onClick={() => handleSubmenuItemClick(item.mnu_itm_url_tx)}
                      onMouseEnter={(e) => {
                        if (!isRowActive(child.mnu_itm_url_tx)) applyMenuHover(e.currentTarget);
                      }}
                      onMouseLeave={(e) => {
                        if (!isRowActive(child.mnu_itm_url_tx)) clearMenuHover(e.currentTarget);
                      }}
                      className="flex items-center px-4 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer group"
                      style={() => ({
                        backgroundColor: isRowActive(child.mnu_itm_url_tx) ? 'var(--theme-sidemenu-active)' : 'transparent',
                        color: isRowActive(child.mnu_itm_url_tx) ? 'var(--theme-primary)' : 'var(--theme-sidemenu-fg)'
                      })}
                    >
                      <div
                        className="icon-circle w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mr-3 transition-all duration-200"
                        style={{
                          backgroundColor: isRowActive(child.mnu_itm_url_tx) ? 'var(--theme-primary)' : (child.mnu_itm_icn_clr_cd ? getLighterColor(child.mnu_itm_icn_clr_cd) : 'var(--theme-bg-secondary)'),
                          border: isRowActive(child.mnu_itm_url_tx) ? `2px solid var(--theme-primary)` : (child.mnu_itm_icn_clr_cd ? `2px solid ${getLighterColor(child.mnu_itm_icn_clr_cd, 0.3)}` : '2px solid var(--theme-border)')
                        }}
                      >
                        <i className={`${child.mnu_itm_icn_tx || 'ri-circle-line'} text-sm transition-colors duration-200 bg-transparent ${isRowActive(child.mnu_itm_url_tx)
                            ? 'sidebar-icon-active'
                            : 'sidebar-icon-inactive'
                          }`}
                          style={child.mnu_itm_icn_clr_cd && !isRowActive(child.mnu_itm_url_tx) ? { color: child.mnu_itm_icn_clr_cd } : undefined}>
                        </i>
                      </div>
                      <span className="flex-1" style={{ color: isRowActive(child.mnu_itm_url_tx) ? '#ffffff' : 'inherit' }}
                      >{child.mnu_itm_nm}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
            </>
          ) : (
            // Single item tooltip
            <div className="px-4 py-3">
              <div className="flex items-center">
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center mr-3"
                  style={{
                    backgroundColor: location.pathname === item.prnt_mnu_itm_url_tx
                      ? 'var(--theme-primary)'
                      : 'transparent',
                    border: location.pathname === item.prnt_mnu_itm_url_tx
                      ? 'none'
                      : '1px solid var(--theme-border)'
                  }}
                >
                  <i className={`${item.prnt_mnu_icn_tx || 'ri-circle-line'} text-base bg-transparent ${location.pathname === item.prnt_mnu_itm_url_tx
                      ? 'sidebar-icon-active'
                      : ''
                    }`}
                    style={{
                      color: location.pathname !== item.prnt_mnu_itm_url_tx ? (item.prnt_mnu_icn_clr_cd || 'var(--theme-primary)') : undefined
                    }}>
                  </i>
                </div>
                <span className="font-medium text-sm" style={{ color: 'var(--theme-sidemenu-fg)' }}>{item.mnu_itm_nm}</span>
              </div>
            </div>
          )}
        </div>

        {/* Tooltip arrow */}
        <div
          className="absolute left-0 top-4 transform -translate-x-2 w-0 h-0"
          style={{
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderRight: '6px solid var(--theme-border)',
          }}
        ></div>
        <div
          className="absolute left-0 top-4 transform -translate-x-1.5 w-0 h-0"
          style={{
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderRight: '6px solid var(--theme-sidemenu-bg)',
          }}
        ></div>
      </div>
    );
  };

  // Render tree node recursively with Windows Explorer-style tree view
  const renderTreeNode = (item: any, level: number = 0, parentKey: string = '', isLastChild: boolean = false, itemIndex: number = 0): React.ReactNode => {
    const itemUrl = item.mnu_itm_url_tx || item.prnt_mnu_itm_url_tx;
    const nodeId = itemUrl || `node-${item.mnu_itm_nm || item.prnt_mnu_itm_nm || 'item'}-${level}-${itemIndex}`;
    const itemKey = `${parentKey}-${nodeId}`;
    const hasChildrenNodes = hasChildren(item);
    const isNodeExpanded = isTreeNodeExpanded(nodeId);
    const itemIsActive = itemUrl ? isActive(itemUrl) : false;
    const hasActiveChild = hasActiveSubItem(item.children);
    const itemName = item.mnu_itm_nm || item.prnt_mnu_itm_nm || '';
    const indentWidth = 20; // pixels per level
    const isHeaderItem = item.hdr_in === 1 || item.hdr_in === true || item.hdr_in === 't' ||
      item.prnt_hdr_in === 1 || item.prnt_hdr_in === true || item.prnt_hdr_in === 't';
    // Parent items (with children) or header items should expand/collapse, not navigate
    const shouldToggleExpand = hasChildrenNodes || isHeaderItem;

    return (
      <div key={itemKey} className="relative select-none">
        {/* Tree node row */}
        <div
          className="flex items-center group relative"
          style={{ paddingLeft: `${level * indentWidth}px`, minHeight: '28px' }}
        >
          {/* Dotted vertical lines for each level */}
          {level > 0 && Array.from({ length: level }).map((_, i) => (
            <div
              key={`vline-${i}`}
              className="absolute top-0 bottom-0"
              style={{
                left: `${i * indentWidth + 8}px`,
                width: '1px',
                borderLeft: '1px dashed #888888'
              }}
            />
          ))}

          {/* Horizontal dotted line to this node */}
          {level > 0 && (
            <div
              className="absolute"
              style={{
                left: `${(level - 1) * indentWidth + 8}px`,
                top: '50%',
                width: `${indentWidth - 4}px`,
                height: '0px',
                borderTop: '1px dashed #888888'
              }}
            />
          )}

          {/* Plus/Minus box for expand/collapse */}
          {hasChildrenNodes ? (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleTreeNode(nodeId);
              }}
              className="relative flex items-center justify-center flex-shrink-0 cursor-pointer z-10"
              style={{
                width: '16px',
                height: '16px',
                backgroundColor: 'var(--theme-sidemenu-bg)',
                border: '1px solid #888888',
                marginRight: '4px'
              }}
              title={isNodeExpanded ? 'Collapse' : 'Expand'}
            >
              {/* Plus or Minus sign */}
              <span
                className="font-bold text-xs leading-none"
                style={{ color: '#888888' }}
              >
                {isNodeExpanded ? '−' : '+'}
              </span>
            </button>
          ) : (
            /* Empty space for alignment when no children */
            <div style={{ width: '20px', flexShrink: 0 }} />
          )}

          {/* Folder/Document icon */}
          <div
            className="flex items-center justify-center flex-shrink-0 mr-1"
            style={{ width: '20px', height: '20px' }}
          >
            <i
              className={`${item.mnu_itm_icn_tx || item.prnt_mnu_icn_tx || (hasChildrenNodes ? (isNodeExpanded ? 'ri-folder-open-line' : 'ri-folder-line') : 'ri-file-text-line')} text-base`}
              style={{
                color: itemIsActive
                  ? '#7c3aed'
                  : hasActiveChild
                    ? '#7c3aed'
                    : (item.mnu_itm_icn_clr_cd || item.prnt_mnu_icn_clr_cd) || (hasChildrenNodes ? '#f0c040' : 'var(--theme-sidemenu-fg)')
              }}
            />
          </div>

          {/* Menu item link or label */}
          {itemUrl && !shouldToggleExpand ? (
            /* Regular navigable item (leaf node with URL) */
            <NavLink
              to={itemUrl}
              end
              onClick={handleTreeViewItemClick}
              className="flex items-center flex-1 px-1.5 py-0.5 text-base transition-all duration-150 cursor-pointer rounded min-w-0"
              style={{
                backgroundColor: itemIsActive ? 'var(--theme-sidemenu-active)' : 'transparent',
                color: itemIsActive ? 'var(--theme-sidemenu-active-fg)' : 'var(--theme-sidemenu-fg)',
                fontWeight: itemIsActive ? 600 : 'normal'
              }}
              onMouseEnter={(e) => {
                if (!itemIsActive) {
                  e.currentTarget.style.setProperty('background-color', 'var(--theme-sidemenu-hover)', 'important');
                  e.currentTarget.style.setProperty('color', '#1f2937', 'important');
                }
              }}
              onMouseLeave={(e) => {
                if (!itemIsActive) {
                  e.currentTarget.style.removeProperty('background-color');
                  e.currentTarget.style.setProperty('color', 'var(--theme-sidemenu-fg)', 'important');
                }
              }}
            >
              <span className="truncate">{itemName}</span>
            </NavLink>
          ) : hasChildrenNodes || isHeaderItem ? (
            /* Parent item or header item - click to expand/collapse */
            <span
              className="flex-1 px-1.5 py-0.5 text-base truncate rounded transition-all duration-150 cursor-pointer"
              style={{
                backgroundColor: hasActiveChild ? 'var(--theme-sidemenu-hover)' : 'transparent',
                color: hasActiveChild ? '#ffffff' : 'var(--theme-sidemenu-fg)',
                fontWeight: hasActiveChild ? 600 : 'normal'
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleTreeNode(nodeId);
              }}
              onMouseEnter={(e) => {
                if (!hasActiveChild) {
                  e.currentTarget.style.backgroundColor = 'var(--theme-sidemenu-hover)';
                  e.currentTarget.style.color = '#1f2937';
                }
              }}
              onMouseLeave={(e) => {
                if (!hasActiveChild) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = 'var(--theme-sidemenu-fg)';
                }
              }}
            >
              {itemName}
            </span>
          ) : (
            /* Leaf node without URL - show background on hover */
            <span
              className="flex-1 px-1.5 py-0.5 text-base truncate rounded transition-all duration-150"
              style={{
                color: 'var(--theme-sidemenu-fg)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--theme-sidemenu-hover)';
                e.currentTarget.style.color = '#1f2937';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = 'var(--theme-sidemenu-fg)';
              }}
            >
              {itemName}
            </span>
          )}

          {/* Drill-down/Pin button - only show for items with children */}
          {hasChildrenNodes && (
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleDrillDown(item);
              }}
              className="flex items-center justify-center flex-shrink-0 rounded transition-all duration-150 cursor-pointer ml-1"
              style={{
                width: '18px',
                height: '18px',
                backgroundColor: 'transparent',
                color: '#888888'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--theme-primary)';
                e.currentTarget.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#888888';
              }}
              title="Pin this folder"
            >
              <i className="ri-pushpin-line text-sm"></i>
            </button>
          )}
        </div>

        {/* Render children if expanded */}
        {hasChildrenNodes && isNodeExpanded && (
          <div className="relative">
            {/* Vertical line connecting to children */}
            <div
              className="absolute"
              style={{
                left: `${level * indentWidth + 8}px`,
                top: 0,
                bottom: 0,
                width: '1px',
                borderLeft: '1px dashed #888888'
              }}
            />
            {orderModuleChildren(item.children).map((child: any, childIndex: number) =>
              renderTreeNode(child, level + 1, itemKey, childIndex === item.children.length - 1, childIndex)
            )}
          </div>
        )}
      </div>
    );
  };

  // Renders one wing (grandparent) and the modules beneath it.
  // Collapsed rail: no room for a label, so wings degrade to a thin separator and
  // the modules stay flat — the icon rail keeps working exactly as before.
  const renderWingGroup = (wing: WingGroup, wingIndex: number, isLastWing: boolean) => {
    const wingKey = `wing-${wing.wng_id}`;

    if (isCollapsed) {
      return (
        <div key={wingKey}>
          {wingIndex > 0 && (
            <div
              /* The rail's divider, not --theme-border: that is the content
                 area's #e5e7eb and drew a pale grey rule across the ink. */
              className="mx-4 my-2 border-t"
              style={{ borderColor: 'var(--theme-sidemenu-divider)' }}
              title={wing.wng_nm}
            />
          )}
          {wing.items.map((item: any, index: number) =>
            renderMenuItem(item, index, index === wing.items.length - 1))}
        </div>
      );
    }

    // Expanded rail: a small muted label on the SAME left margin as the module
    // names beneath it, with air above it. It used to be centred between two
    // fading hairlines — "—— ADMINISTRATION ——" — which is three pieces of
    // furniture doing a job whitespace does for free, and which broke the rail's
    // left edge into two different alignments (centred labels over a left-aligned
    // list). Not a button, not collapsible, no icon, no count, no chevron.
    //
    // Wing names are seeded as "<Something> Wing" — the reference drops that
    // suffix ("ADMINISTRATION", not "ADMINISTRATION WING"); the full name still
    // shows in the tooltip.
    const wingLabel = wing.wng_nm.replace(/\s+wing\s*$/i, '') || wing.wng_nm;

    return (
      <div key={wingKey} className={isLastWing ? '' : 'mb-0.5'}>
        <div
          title={wing.wng_nm}
          className={`flex items-center px-2.5 pb-1.5 select-none ${wingIndex === 0 && !filteredMenuItems.some(isDashboardItem) ? 'pt-1' : 'pt-5'}`}
        >
          <span className="wing-label whitespace-nowrap">
            {wingLabel}
          </span>
        </div>

        <div>
          {wing.items.map((item: any, index: number) =>
            renderMenuItem(item, index, index === wing.items.length - 1))}
        </div>
      </div>
    );
  };

  /* A module named "... (NEW)" — WMS (NEW) — shows the suffix as a small green
     badge instead of as part of the label. Presentation only; the name is unchanged. */
  const renderModuleLabel = (name: string, className: string) => {
    const match = /^(.*?)\s*\(new\)\s*$/i.exec(name || '');
    if (!match) return <span className={className}>{name}</span>;
    return (
      <span className={`${className} inline-flex items-center gap-2`}>
        <span className="module-name-text">{match[1]}</span>
        <span className="rail-new-badge flex-shrink-0">NEW</span>
      </span>
    );
  };

  const renderMenuItem = (item: any, index: number, isLastInGroup: boolean = false) => {
    // A module row can be current in two different ways, and they must not look the
    // same. itemIsSelfActive = this row's own route is open. itemIsAncestor = one of
    // its sub-modules is open, and the sub-module already draws the solid pill just
    // below — painting the parent with the same pill put two identical "you are here"
    // markers on screen at once (Finance + Finance > Dashboard), so the eye could not
    // tell which one it had actually clicked. The ancestor gets a quieter cue instead.
    const itemIsSelfActive = isActive(menuPath(item));
    const itemIsAncestor = !itemIsSelfActive && hasActiveSubItem(item.children);
    const itemIsActive = itemIsSelfActive || itemIsAncestor;
    const itemIsExpanded = isExpanded(menuPath(item));
    // Use a stable unique key per parent item. Include index to guarantee uniqueness within the list.
    const parentKey = `parent-${index}-${item.prnt_mnu_itm_id ?? 'none'}-${item.prnt_mnu_itm_url_tx ?? item.mnu_itm_url_tx ?? item.mnu_itm_nm}`;

    // Handle header items - show as heading when hdr_in/prnt_hdr_in is set, or URL is null/empty.
    // hdr_in is a Postgres BOOLEAN, so it arrives as true / 't' / 1 depending on the driver
    // and serialisation. Testing `=== 1` alone never matched, which made section headings
    // (PLANNING, SANCTIONS, EXECUTION (AWARD)…) render as clickable links to /app#planning.
    // Kept in step with the tree-view check at line ~1666.
    // The item is itself the section header (vs. merely sitting under one).
    const isOwnHeader = item?.hdr_in === 1 || item?.hdr_in === true || item?.hdr_in === 't';
    const isHeaderItem =
      isOwnHeader ||
      item?.prnt_hdr_in === 1 || item?.prnt_hdr_in === true || item?.prnt_hdr_in === 't' ||
      (!item?.mnu_itm_url_tx && !item?.prnt_mnu_itm_url_tx && !item?.children);

    if (isHeaderItem) {
      if (isCollapsed && item.children && item.children.length > 0) {
        // When collapsed, clicking the group icon expands the rail (no flyout); its
        // children then show inline under the header in the expanded list.
        return (
          <div key={parentKey} className="relative">
            <button
              onClick={() => { onToggleCollapse(); }}
              onMouseEnter={(e) => {
                handleMenuItemHover(item, e);
                if (secondarySidebar.item?.prnt_mnu_itm_url_tx !== item.prnt_mnu_itm_url_tx) applyMenuHover(e.currentTarget);
              }}
              onMouseLeave={(e) => {
                handleMenuItemLeave();
                if (secondarySidebar.item?.prnt_mnu_itm_url_tx !== item.prnt_mnu_itm_url_tx) clearMenuHover(e.currentTarget);
              }}
              className="rail-row w-full flex items-center justify-center p-1.5 cursor-pointer group relative hover:bg-transparent focus:bg-transparent focus:outline-none"
              style={{
                backgroundColor: secondarySidebar.item?.prnt_mnu_itm_url_tx === item.prnt_mnu_itm_url_tx
                  ? 'var(--theme-sidemenu-hover)'
                  : undefined
              }}
            >
              {/* Bare slot — see the note on the parent row's icon. */}
              <div className="icon-circle relative z-10">
                <i className={`rail-top-icon ${item.prnt_mnu_icn_tx || 'ri-folder-line'} text-lg transition-colors duration-200 bg-transparent ${secondarySidebar.item?.mnu_itm_url_tx === item.prnt_mnu_itm_url_tx
                    ? 'sidebar-icon-active'
                    : 'sidebar-icon-inactive'
                  }`}
                  style={item.prnt_mnu_icn_clr_cd && secondarySidebar.item?.mnu_itm_url_tx !== item.prnt_mnu_itm_url_tx ? { color: item.prnt_mnu_icn_clr_cd } : undefined}>
                </i>
              </div>
            </button>
            {renderPopupMenu(item)}
          </div>
        );
      } else if (isCollapsed) {
        // Show minimal separator line when collapsed and no children
        return (
          <div key={parentKey} className="flex justify-center py-2 relative">
            <div
              className="w-6 h-px"
              style={{ backgroundColor: 'var(--theme-sidemenu-divider)' }}
            />
          </div>
        );
      }
      // groupByHeaders() turns a header into the PARENT of the items that follow it, so
      // a header usually arrives carrying children. Rendering only the label would
      // silently swallow them — the section titles would show with nothing underneath.
      const headerChildren: any[] = Array.isArray(item.children) ? item.children : [];
      return (
        <div key={parentKey}>
          {/* Same treatment as a wing label, one tier down: a muted eyebrow on the
              rows' own left margin. The violet accent bar that used to sit here
              was the SAME cue the active row uses, on a thing that is not a row
              and cannot be current — so every section printed a decoy "you are
              here" marker down the rail. */}
          <div className="flex items-center px-2.5 pt-4 pb-1.5 select-none">
            <span className="rail-eyebrow">
              {/*
                When the item is ITSELF the header (hdr_in), its own name is the section
                title — "Planning", "Sanctions", … Falling back to prnt_mnu_itm_nm here
                would print the containing module ("WMS (NEW)") once per section.
                prnt_mnu_itm_nm is only right for the older shape, where a header was
                inferred from the parent via prnt_hdr_in.
              */}
              {isOwnHeader
                ? (item.mnu_itm_nm || item.prnt_mnu_itm_nm)
                : (item.prnt_mnu_itm_nm || item.mnu_itm_nm)}
            </span>
          </div>
          {headerChildren.map((child: any, childIndex: number) =>
            renderMenuItem(child, childIndex, childIndex === headerChildren.length - 1)
          )}
        </div>
      );
    }

    return (
      <div key={parentKey} className="relative mb-0">
        {item.children ? (
          <div className="relative">
            {/* Parent menu item */}
            <button
              onClick={() => handleParentMenuClick(item)}
              onMouseEnter={(e) => {
                handleMenuItemHover(item, e);
                const isCurrentlyActive = location.pathname === item.prnt_mnu_itm_url_tx || hasActiveSubItem(item.children);
                if (!isCurrentlyActive) applyMenuHover(e.currentTarget);
              }}
              onMouseLeave={(e) => {
                handleMenuItemLeave();
                const isCurrentlyActive = location.pathname === item.prnt_mnu_itm_url_tx || hasActiveSubItem(item.children);
                const isSecondarySidebarOpen = (item.prnt_mnu_vw_in === 'sidemenu' || item.prnt_mnu_vw_in === 'cardmenu' || item.prnt_mnu_vw_in == 1) && secondarySidebar.item?.mnu_itm_url_tx === item.prnt_mnu_itm_url_tx;
                if (!isCurrentlyActive && !isSecondarySidebarOpen) clearMenuHover(e.currentTarget);
              }}
              /*
                The state now travels as CLASSES, not as an inline style object.
                `is-active` and `is-ancestor` are what the stylesheet hangs the
                tinted sheet, the white label and the edge spine off — and a
                pseudo-element (which is what the spine is) cannot be reached from
                an inline style at all, which is why the old rail declared a marker
                it could never draw on a parent row.

                It also puts the two states in ONE place. They were previously
                spread across four inline ternaries that each had to re-derive
                "self-active vs ancestor vs flyout-open vs nothing", and they had
                already drifted apart: the ancestor branch painted the hover fill,
                so a module whose child was open looked permanently hovered.
              */
              className={`rail-row w-full flex items-center cursor-pointer group relative
                ${(isCollapsed && !isOpen) ? 'justify-center p-1.5' : 'justify-between pl-3 pr-2 py-1'}
                ${itemIsSelfActive ? 'is-active' : ''}
                ${itemIsAncestor ? 'is-ancestor' : ''}
                hover:bg-transparent focus:bg-transparent focus:outline-none
              `}
              style={{
                backgroundColor: (item.prnt_mnu_vw_in === 'sidemenu' || item.prnt_mnu_vw_in === 'cardmenu' || item.prnt_mnu_vw_in == 1) && secondarySidebar.item?.mnu_itm_url_tx === item.prnt_mnu_itm_url_tx
                  ? 'var(--theme-sidemenu-hover)'
                  : undefined,
                color: 'var(--theme-sidemenu-fg)'
              }}
            >
              <div className="flex items-center relative min-w-0 flex-1">
                {/* No fill, no ring, no shadow — .icon-circle is a bare 20px slot
                    now and the stylesheet owns it. Sixteen bordered discs down a
                    256px column drew sixteen boxes, and boxes read as controls,
                    so the eye kept landing on the containers instead of on the
                    module names inside them. */}
                <div
                  className={`icon-circle relative z-10 ${(isCollapsed && !isOpen) ? 'mx-auto' : 'mr-3'}`}
                >
                  <i className={`rail-top-icon ${item.prnt_mnu_icn_tx || 'ri-circle-line'} text-lg transition-colors duration-200 bg-transparent ${itemIsActive
                      ? 'sidebar-icon-active'
                      : 'sidebar-icon-inactive'
                    }`}
                    style={item.prnt_mnu_icn_clr_cd && !itemIsActive ? { color: item.prnt_mnu_icn_clr_cd } : undefined}>
                  </i>
                </div>
                {(!isCollapsed || isOpen) &&
                  renderModuleLabel(
                    item.prnt_mnu_itm_nm || item.mnu_itm_nm,
                    'module-name transition-all duration-200 text-sm font-medium relative z-10 min-w-0 text-left'
                  )}
              </div>
              {(!isCollapsed || isOpen) && (
                /*
                  Both controls used to be painted at full strength on every module
                  row, which put 32 small glyphs permanently down the right edge of
                  a 256px rail and gave the pin — used rarely — the same weight as
                  the module name next to it.

                  The chevron stays because it carries state (open / closed) but
                  rests at 40% until the row is pointed at; the pin appears on
                  hover or keyboard focus. Both fade by OPACITY, never by display,
                  so the hit targets never move under the cursor and Tab still
                  reaches the pin on a row nobody is hovering. See .rail-ctrl.
                */
                <div className="flex items-center flex-shrink-0 self-center">
                  {/* Pin — drills the rail into this module (see renderRowPin). */}
                  {renderRowPin(item)}
                  {/* The pin used to sit here. It drilled the rail down to one
                      module — a real feature, but a second control competing with
                      the module name on all 16 rows, and on the CURRENT row it was
                      pinned open permanently (.rail-row.is-active reveals its
                      controls), so the row you were on was the one row that always
                      carried an extra glyph. Removed per request.

                      handleDrillDown and the whole drill-down/breadcrumb path are
                      untouched — the tree view still triggers it, and a rail left
                      drilled-in restores from localStorage on reload. */}
                  {/* Triangle toggle — expands/collapses the sub-modules inline below this module */}
                  <span
                    role="button"
                    tabIndex={0}
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleParentMenuClick(item); }}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); handleParentMenuClick(item); } }}
                    className="rail-ctrl w-[22px] h-[22px] flex items-center justify-center rounded-md cursor-pointer"
                    title={itemIsExpanded ? 'Hide sub-modules' : 'Show sub-modules'}
                  >
                    <i className={`sidebar-ctrl-icon ri-arrow-right-s-line transition-transform duration-200 ${itemIsExpanded ? 'rotate-90' : 'rotate-0'}`}></i>
                  </span>
                </div>
              )}
            </button>

            {/* Submenu Section — inline accordion below the module for ALL parent types when the
                rail is expanded (or on mobile). The collapsed desktop rail uses the flyout/popup.

                The submenu sizes to its content rather than being capped. A previous
                `max-h-[500px] overflow-y-auto` gave any module with more than ~12
                options its own inner scrollbar, so later options sat hidden behind a
                scroll. Animating grid-rows 0fr -> 1fr reaches the natural height with
                no magic maximum, so every option shows however many there are; the
                sidebar as a whole still scrolls when the full list outgrows the
                viewport. */}
            {(!isCollapsed || isOpen) && (
                <div className={`ml-0 grid transition-all duration-300 ease-in-out relative
                ${itemIsExpanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}
              `}>
                  <div className="overflow-hidden min-h-0">
                  {/* rail-sub draws the 1px guide line the options hang off. A
                      nested list that is only indented is ambiguous the moment two
                      modules are open at once — the line is what makes "these
                      belong to that" readable without counting pixels. */}
                  <div className="rail-sub space-y-0.5 pt-1 pb-1.5 pr-1">
                    {(() => {
                      // Section headers (hdr_in) arrive in this list as SIBLINGS of the
                      // options they head, so mapping every child straight to a NavLink
                      // rendered "Planning" / "Sanctions" / "Execution (Award)" as ordinary
                      // icon rows — the same tier as Proposals or Estimates. The pinned
                      // (drill-down) list goes through renderMenuItem and gets this right;
                      // this accordion is the other path, so it needs the same check.
                      // Label styling mirrors renderMenuItem's header branch (~line 2136).
                      const renderSubLink = (subChild: any, subIndex: number) => (
                        <div key={subChild.mnu_itm_url_tx || `sub-${subIndex}-${subChild.mnu_itm_nm}`} className="relative">
                          <NavLink
                            to={subChild.mnu_itm_url_tx}
                            /* Exact match everywhere, except the Display Devices rows
                               that own a sub-tree or redirect into one — see
                               matchesBySubTree. */
                            end={!matchesBySubTree(subChild.mnu_itm_url_tx)}
                            onClick={() => handleSubmenuItemClick(item.prnt_mnu_itm_url_tx)}
                            onMouseEnter={(e) => {
                              if (!isRowActive(subChild.mnu_itm_url_tx)) applyMenuHover(e.currentTarget);
                            }}
                            onMouseLeave={(e) => {
                              if (!isRowActive(subChild.mnu_itm_url_tx)) clearMenuHover(e.currentTarget);
                            }}
                            aria-current={isRowActive(subChild.mnu_itm_url_tx) ? 'page' : undefined}
                            /* NavLink puts `active` on the open leaf; the stylesheet
                               reads that for the fill and for the dot on the guide
                               line. The inline style that used to set the active
                               colour painted --theme-primary, which is the CONTENT
                               area's brand token — a mid violet that sat almost
                               invisibly on the violet fill right behind it. */
                            className="rail-subrow flex items-center pl-2.5 pr-2 cursor-pointer focus:outline-none relative"
                          >
                            {/* Small coloured tile: the option's own colour when the menu
                                row carries one (mnu_itm_icn_clr_cd), else the palette's. */}
                            <span
                              className="sub-tile mr-2.5 relative z-10"
                              style={/^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(subChild.mnu_itm_icn_clr_cd || '')
                                ? ({ '--tile': subChild.mnu_itm_icn_clr_cd } as React.CSSProperties)
                                : undefined}
                            >
                              <i className={`sub-module-icon ${subChild.mnu_itm_icn_tx || 'ri-circle-line'} bg-transparent`}></i>
                            </span>
                            <span className="module-name transition-opacity duration-200 relative z-10">{subChild.mnu_itm_nm}</span>
                          </NavLink>
                        </div>
                      );

                      return orderModuleChildren(item.children).map((child: any, childIndex: number) => {
                        const childIsHeader = child.hdr_in === 1 || child.hdr_in === true || child.hdr_in === 't';
                        if (!childIsHeader) return renderSubLink(child, childIndex);

                        // groupByHeaders() can also hand a header the items that follow it
                        // as its own children. Render those inline so the options aren't
                        // swallowed whichever shape the data arrives in.
                        const headerChildren: any[] = Array.isArray(child.children) ? child.children : [];
                        return (
                          <div key={`sub-hdr-${childIndex}-${child.mnu_itm_nm}`}>
                            {/* Same eyebrow as the pinned list — see the note there
                                about why the violet accent bar had to go. */}
                            <div className={`flex items-center px-2 pb-1 select-none ${childIndex === 0 ? 'pt-1.5' : 'pt-3'}`}>
                              <span className="rail-eyebrow">
                                {child.mnu_itm_nm || child.prnt_mnu_itm_nm}
                              </span>
                            </div>
                            {headerChildren.map(renderSubLink)}
                          </div>
                        );
                      });
                    })()}
                  </div>
                  </div>
                </div>
              )}

            {renderPopupMenu(item)}
          </div>
        ) : (
          <div className="relative">
            <NavLink
              to={item.mnu_itm_url_tx}
              end
              onClick={handleSingleMenuItemClick}
              onMouseEnter={(e) => {
                handleMenuItemHover(item, e);
                if (location.pathname !== item.mnu_itm_url_tx) applyMenuHover(e.currentTarget);
              }}
              onMouseLeave={(e) => {
                handleMenuItemLeave();
                if (location.pathname !== item.mnu_itm_url_tx) clearMenuHover(e.currentTarget);
              }}
              aria-current={location.pathname === item.mnu_itm_url_tx ? 'page' : undefined}
              /* rail-row is what the spine hangs off (see .rail-row.is-active::before);
                 NavLink supplies `active` itself, so the two together cover both the
                 fill and the edge marker with no inline style involved. The colours
                 that used to be set here painted --theme-primary — the CONTENT
                 area's brand token, not the rail's — on the active row. */
              className={({ isActive: navActive }) => `rail-row flex items-center cursor-pointer group relative focus:outline-none ${navActive ? 'active is-active' : ''
                }`}
              style={{
                padding: (isCollapsed && !isOpen) ? '0.375rem' : '0.25rem 0.5rem 0.25rem 0.75rem',
                justifyContent: (isCollapsed && !isOpen) ? 'center' : 'flex-start',
                color: 'var(--theme-sidemenu-fg)'
              }}
            >

              {/* Bare slot — see the note on the parent row's icon. */}
              <div
                className={`icon-circle relative z-10 ${(isCollapsed && !isOpen) ? 'mx-auto' : 'mr-3'}`}
              >
                <i className={`rail-top-icon ${item.mnu_itm_icn_tx || 'ri-circle-line'} text-lg transition-colors duration-200 bg-transparent ${location.pathname === item.mnu_itm_url_tx
                    ? 'sidebar-icon-active'
                    : 'sidebar-icon-inactive'
                  }`}
                  style={item.mnu_itm_icn_clr_cd && location.pathname !== item.mnu_itm_url_tx ? { color: item.mnu_itm_icn_clr_cd } : undefined}>
                </i>
              </div>
              {(!isCollapsed || isOpen) &&
                renderModuleLabel(item.mnu_itm_nm, 'module-name transition-all duration-300 text-sm font-medium relative z-10 min-w-0 flex-1')}
            </NavLink>

            {renderPopupMenu(item)}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Below lg: a fixed drawer, edge to edge. From lg up: a white card that
          sits in the shell's flex row beside the content and pins below the top
          header (--app-header-h is published by components/Header.tsx). */}
      <aside
        ref={asideRef}
        className={`sidebar-container fixed left-0 top-0 h-full flex flex-col transition-all duration-300 z-[6000]
          lg:sticky lg:top-[calc(var(--app-header-h,4.25rem)+16px)] lg:h-[calc(100vh-var(--app-header-h,4.25rem)-32px)] lg:self-start lg:flex-shrink-0
          ${(isCollapsed && !isOpen) ? 'w-[72px] rail-collapsed' : 'w-[260px]'}
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
        style={{
          backgroundColor: '#06142b',
          /*
           * The ground: the same planned-city plate as the login screen
           * (AuthShell's HERO_IMAGE), under a navy wash. The wash is denser
           * than the login's — this plate carries 13px menu labels rather
           * than a 2.6rem headline — and densest at the foot, where the long
           * module list runs. The violet bloom on ::before still paints above
           * all of this (the element's own background is always bottom-most).
           */
          backgroundImage: [
            'linear-gradient(180deg, rgba(6,20,43,0.80) 0%, rgba(8,24,52,0.86) 35%, rgba(6,20,43,0.93) 70%, rgba(4,13,30,0.97) 100%)',
            "url('/images/hero/hero-bg-1.jpg')",
          ].join(', '),
          backgroundSize: 'cover',
          backgroundPosition: '50% 58%',
          backgroundRepeat: 'no-repeat',
          borderColor: 'var(--theme-sidemenu-divider)',
          color: 'var(--theme-sidemenu-fg)',
          /*
           * NO DROP SHADOW. This was a 30px violet bloom thrown across the content
           * area, which is the thing that dated the rail more than any single
           * colour in it: a panel that casts a coloured shadow onto the page is
           * claiming to float above the app, and a sidebar is not a floating
           * panel — it is the app's left edge.
           *
           * A near-black rail against a near-white page separates on contrast
           * alone. The 1px border above is there for the case where a theme puts
           * a dark body next to it, and for nothing else.
           */
          boxShadow: 'none'
        }}
        data-theme="sidebar"
        /* Light mode draws the rail in off-cream with saffron accents; see the
           CREAM SKIN block in the injected stylesheet. Dark mode ignores it. */
        data-skin="cream"
      >
        {/* ---- TOP ROW -------------------------------------------------------
            The emblem and the department name moved up into the top header
            (components/Header.tsx), and so did the menu search — it writes the
            same useSidebarStore.searchTerm this rail filters on. What is left
            is a little top air, and the collapse toggle, which sits on the
            card's right edge, half outside it.

            Keeps the .sidebar-logo-section class: themeService's inBrand()
            check looks for it to skip this block — do not rename it.

            The toggle is desktop only (`hidden lg:flex`): below lg the rail is
            a drawer and collapse does nothing; the drawer is closed by the
            header's hamburger / the backdrop. */}
        {/* Menu search — filters this rail live (useSidebarStore.searchTerm).
            Collapsed: a search icon that expands the rail and focuses the field. */}
        <div className="sidebar-logo-section flex-shrink-0 px-3 pt-3 pb-1">
          {!(isCollapsed && !isOpen) ? (
            <div className="relative">
              <i className="rail-search-icon ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-[15px] pointer-events-none"></i>
              <input
                ref={searchInputRef}
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    setSearchTerm('');
                    e.currentTarget.blur();
                  }
                }}
                placeholder="Search menu…"
                aria-label="Search menu items"
                title="Search menu items (Ctrl+K)"
                autoComplete="off"
                spellCheck={false}
                className="rail-search-input w-full h-10 pl-9 pr-14"
              />
              {searchTerm ? (
                <button
                  type="button"
                  onClick={() => setSearchTerm('')}
                  className="rail-search-clear absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 inline-flex items-center justify-center rounded-md"
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="ri-close-line text-sm"></i>
                </button>
              ) : (
                <kbd className="rail-search-kbd hidden lg:inline-flex absolute right-2 top-1/2 -translate-y-1/2 items-center px-1.5 py-0.5 text-[10px] font-semibold rounded-md pointer-events-none">
                  Ctrl K
                </kbd>
              )}
            </div>
          ) : (
            <button
              type="button"
              onClick={() => { onToggleCollapse(); setTimeout(() => searchInputRef.current?.focus(), 320); }}
              className="rail-search-collapsed w-full h-10 flex items-center justify-center rounded-[10px]"
              title="Search menu (Ctrl+K)"
              aria-label="Search menu"
            >
              <i className="ri-search-line text-[18px]"></i>
            </button>
          )}
        </div>
        <button
          type="button"
          onClick={onToggleCollapse}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          className="rail-collapse-btn hidden lg:flex absolute -right-[13px] top-1/2 -translate-y-1/2 z-20 items-center justify-center w-[26px] h-[26px] rounded-full transition-transform duration-200 hover:scale-110"
        >
          <i className={`${isCollapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'} text-[16px] leading-none`} />
        </button>

        {/* min-h-0 is what makes flex-1 actually work here: a flex child's default
            min-height is auto, i.e. "as tall as my content", so the nav grew past
            the viewport and never scrolled — which is why this carried a hardcoded
            `calc(100vh - 120px)` that had to be re-guessed every time the brand or
            search band changed height. The aside is a flex column now; the nav
            takes what is left and scrolls, whatever the chrome above it measures. */}
        <nav
          ref={menuNavRef}
          className="flex-1 min-h-0 py-3 overflow-y-auto relative"
        >

          {/* Drill-down Header - Show when drilled into a parent (pin), in tree OR list view */}
          {!isCollapsed && currentDrillDownItem && (
            <div className="drill-breadcrumb px-2.5 pb-2.5 border-b mb-2" style={{ borderColor: 'var(--theme-sidemenu-divider)' }}>
              {/* Breadcrumb navigation */}
              <div className="flex items-center gap-1 text-xs mb-2 flex-wrap" style={{ color: 'var(--theme-sidemenu-fg)', opacity: 0.7 }}>
                <button
                  onClick={handleDrillToRoot}
                  className="hover:underline flex items-center gap-1"
                  style={{ color: 'var(--theme-primary)' }}
                >
                  <i className="ri-home-4-line"></i>
                  <span>Home</span>
                </button>
                {drillDownStack.map((item, idx) => (
                  <React.Fragment key={idx}>
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    {idx < drillDownStack.length - 1 ? (
                      <button
                        onClick={() => setDrillDownStack(drillDownStack.slice(0, idx + 1))}
                        className="hover:underline truncate max-w-[80px]"
                        style={{ color: 'var(--theme-primary)' }}
                        title={item.mnu_itm_nm || item.prnt_mnu_itm_nm}
                      >
                        {item.mnu_itm_nm || item.prnt_mnu_itm_nm}
                      </button>
                    ) : (
                      <span className="truncate max-w-[80px] font-medium" title={item.mnu_itm_nm || item.prnt_mnu_itm_nm}>
                        {item.mnu_itm_nm || item.prnt_mnu_itm_nm}
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </div>
              {/* Back button and current parent */}
              <div className="flex items-center gap-2">
                <button
                  onClick={handleDrillUp}
                  className="p-1.5 rounded-lg transition-all duration-200 flex items-center justify-center"
                  /* --theme-bg-secondary is #ffffff in light mode: this drew a
                     WHITE button on the ink rail. Every colour here is the rail's
                     own glass now, and hover brightens it rather than filling it
                     with the content area's brand violet. */
                  style={{
                    backgroundColor: 'var(--theme-sidemenu-glass)',
                    color: 'var(--theme-sidemenu-fg)',
                    border: '1px solid var(--theme-sidemenu-glass-border)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--theme-sidemenu-hover)';
                    e.currentTarget.style.color = 'var(--theme-sidemenu-hover-fg)';
                    e.currentTarget.style.borderColor = 'var(--theme-sidemenu-marker)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--theme-sidemenu-glass)';
                    e.currentTarget.style.color = 'var(--theme-sidemenu-fg)';
                    e.currentTarget.style.borderColor = 'var(--theme-sidemenu-glass-border)';
                  }}
                  title="Go back"
                >
                  <i className="ri-arrow-left-line text-sm"></i>
                </button>
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <div
                    className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{
                      backgroundColor: 'var(--theme-sidemenu-glass)',
                      border: '1px solid var(--theme-sidemenu-glass-border)',
                      color: 'var(--theme-sidemenu-active-icon)'
                    }}
                  >
                    <i className={`${currentDrillDownItem.mnu_itm_icn_tx || currentDrillDownItem.prnt_mnu_icn_tx || 'ri-folder-line'} text-sm`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-sm truncate" style={{ color: 'var(--theme-sidemenu-fg)' }}>
                      {currentDrillDownItem.mnu_itm_nm || currentDrillDownItem.prnt_mnu_itm_nm}
                    </h3>
                    <p className="text-xs truncate" style={{ color: 'var(--theme-sidemenu-eyebrow)' }}>
                      {currentDrillDownItem.children?.length || 0} items
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Menu Items */}
          {/* The gutter lives here, not on each row: rows are inset by --rail-gutter
              so the active spine can reach back out to the rail's edge at exactly
              -1 * gutter. Padding on the rows themselves would put the spine
              inside the row's own box, floating in the middle of the gutter. */}
          <div
            className={`${debouncedSearchTerm ? 'pt-2' : ''} pb-4 relative`}
            style={{ paddingLeft: 'var(--rail-gutter)', paddingRight: 'var(--rail-gutter)' }}
          >
            {isMenuLoading ? (
              <MenuSkeleton />
            ) : viewMode === 'tree' && !isCollapsed ? (
              // Tree view (only when expanded) - show items based on drill-down state
              <div className="space-y-0.5 py-1">
                {currentDrillDownItem ? (
                  // Show drilled-down children
                  currentDrillDownItem.children && currentDrillDownItem.children.length > 0 ? (
                    orderModuleChildren(currentDrillDownItem.children).map((item: any, index: number) =>
                      renderTreeNode(item, 0, `drill-${index}`, index === currentDrillDownItem.children.length - 1, index)
                    )
                  ) : (
                    <div className="px-4 py-8 text-center" style={{ color: 'var(--theme-sidemenu-eyebrow)' }}>
                      <i className="ri-folder-line text-2xl mb-2"></i>
                      <p className="text-sm">No items in this folder</p>
                    </div>
                  )
                ) : (
                  // Show root tree structure
                  treeStructure.length > 0 ? (
                    treeStructure.map((item, index) =>
                      renderTreeNode(item, 0, `tree-root-${index}`, index === treeStructure.length - 1, index)
                    )
                  ) : (
                    <div className="px-4 py-8 text-center" style={{ color: 'var(--theme-sidemenu-eyebrow)' }}>
                      <i className="ri-folder-line text-2xl mb-2"></i>
                      <p className="text-sm">No menu items available</p>
                    </div>
                  )
                )}
              </div>
            ) : (
              // List view (default) or collapsed tree view - show icon list.
              // When pinned (drilled into a module) and expanded, show ONLY that module's
              // sub-modules; the pinned module name is shown in the breadcrumb header above.
              (() => {
                // Drilled into a module: we are already inside one wing, so show that
                // module's sub-modules flat — no grandparent header here.
                if (currentDrillDownItem && !isCollapsed && !debouncedSearchTerm) {
                  const drillItems = currentDrillDownItem.children || [];
                  return drillItems.map((item: any, index: number) =>
                    renderMenuItem(item, index, index === drillItems.length - 1));
                }

                // Root list: Dashboard is pinned above every wing (see hoistDashboard),
                // then the remaining modules are grouped under their wing (grandparent tier).
                const pinned = filteredMenuItems.filter(isDashboardItem);
                const wings = groupByWings(filteredMenuItems.filter(item => !isDashboardItem(item)));
                return (
                  <>
                    {pinned.length > 0 && (
                      <div className="mb-1">
                        {/* The pinned Dashboard gets its own eyebrow, like a wing. */}
                        {!isCollapsed && (
                          <div className="flex items-center px-2.5 pt-1 pb-1.5 select-none">
                            <span className="wing-label whitespace-nowrap">Overview</span>
                          </div>
                        )}
                        {pinned.map((item: any, index: number) =>
                          renderMenuItem(item, index, index === pinned.length - 1))}
                        {isCollapsed && (
                          <div
                            className="mx-4 my-2 border-t"
                            style={{ borderColor: 'var(--theme-sidemenu-divider)' }}
                          />
                        )}
                      </div>
                    )}
                    {wings.map((wing, wingIndex) =>
                      renderWingGroup(wing, wingIndex, wingIndex === wings.length - 1))}
                  </>
                );
              })()
            )}
          </div>

          {/* Show loading state when searching */}
          {!isMenuLoading && searchTerm && searchTerm !== debouncedSearchTerm && (
            <ListSkeleton rows={4} avatar={false} className="px-4 py-3" />
          )}

          {/* Show message when no search results */}
          {!isMenuLoading && debouncedSearchTerm && filteredMenuItems.length === 0 && (
            <div className="px-4 py-8 text-center" style={{ color: 'var(--theme-sidemenu-eyebrow)' }}>
              <i className="ri-search-line text-2xl mb-2"></i>
              <p className="text-sm">No menu items found</p>
              <p className="text-xs mt-1">Try a different search term</p>
            </div>
          )}

          {/* Show search results count */}
          {!isMenuLoading && debouncedSearchTerm && (
            /* Was a light-grey band with grey text pinned under the results —
               the one solid pale rectangle left on the ink rail. */
            <div className="px-4 py-2 text-center text-xs border-t" style={{ borderColor: 'var(--theme-sidemenu-divider)', color: 'var(--theme-sidemenu-eyebrow)' }}>
              {filteredMenuItems.length > 0
                ? `Found ${filteredMenuItems.length} menu item${filteredMenuItems.length !== 1 ? 's' : ''}`
                : 'No results found'
              }
            </div>
          )}
        </nav>

      </aside>

      {/* Secondary Sidebar */}
      {renderSecondarySidebar()}
    </>
  );
};

export default Sidebar;
